(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["active-filters"] && !Shopify.designMode) return;
  try {
    // Intercept active-filter pill + "Clear all" clicks for AJAX navigation.
//
// These pills live inside [data-collection-content], which ajaxFilterUpdate()
// wipes and rebuilds (replaceChildren) on every filter change. A listener bound
// to the pill container — or the pills themselves — dies with that swap, and the
// theme's inlined javascript runs only once globally, so it never re-binds. After
// the first AJAX update the pills would fall back to full-page navigation (the
// "weird reload"), and the Sideboard sidebar facets/counts would never refresh.
//
// Delegating from document survives every swap, so removing a pill always routes
// through ajaxFilterUpdate(): it updates the URL (pushState) AND fires
// collection:updated, which refreshes the sidebar's backend filters + counts.
document.addEventListener('click', function(e) {
  // Find the clicked link (pill or clear all), scoped to an active-filters bar
  // so we never hijack unrelated links elsewhere on the page.
  var link = e.target.closest('[data-filter-pill], [data-clear-all]');
  if (!link || !link.closest('[data-active-filters]')) return;

  var href = link.getAttribute('href');
  if (!href) return;

  // Use AJAX update if available; otherwise let the default navigation happen.
  if (typeof window.ajaxFilterUpdate === 'function') {
    e.preventDefault();
    window.ajaxFilterUpdate(href);
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["advanced-search-form"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  var SEARCH_THRESHOLD = 12;

  function AdvancedSearch(root) {
    this.root = root;
    this.endpoint = root.dataset.endpoint;
    this.searchUrl = root.dataset.searchUrl || '/search';
    this.i18n = {
      optionsSearch: root.dataset.i18nOptionsSearch,
      from: root.dataset.i18nPriceFrom,
      to: root.dataset.i18nPriceTo,
      allGames: root.dataset.i18nAllGames,
      soloGame: root.dataset.i18nSoloGame
    };

    this.els = {
      loading: root.querySelector('[data-adv-loading]'),
      error: root.querySelector('[data-adv-error]'),
      form: root.querySelector('[data-adv-form]'),
      gameStep: root.querySelector('[data-adv-game-step]'),
      gameGrid: root.querySelector('[data-adv-game-grid]'),
      solo: root.querySelector('[data-adv-solo]'),
      shared: root.querySelector('[data-adv-shared]'),
      gameFields: root.querySelector('[data-adv-games-fields]'),
      clear: root.querySelector('[data-adv-clear]')
    };

    this.schema = null;
    this.games = []; // [] means no game restriction

    this.init();
  }

  AdvancedSearch.prototype.init = function () {
    var self = this;

    this.els.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.submit();
    });
    this.els.clear.addEventListener('click', function () {
      self.games = self.defaultGames();
      self.render();
    });

    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 5000);

    fetch(this.endpoint, { headers: { Accept: 'application/json' }, signal: controller.signal })
      .then(function (r) {
        clearTimeout(timeout);
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (schema) {
        if (schema.success === false) throw new Error('schema unavailable');
        self.schema = schema;

        self.els.loading.hidden = true;
        self.els.form.hidden = false;
        self.syncFromLocation();

        // The sidebar changes the URL in place (pushState, then collection:updated),
        // so rebuild from it each time or the panel reopens with stale choices.
        document.addEventListener('collection:updated', function () {
          self.syncFromLocation();
        });
      })
      .catch(function (err) {
        console.error('[AdvancedSearch]', err);
        self.els.loading.hidden = true;
        self.els.error.hidden = false;
      });
  };

  // Read the URL's `games` before rendering, not after: renderGames() ticks a
  // checkbox off self.games, and renderGameFields() needs it to know which game
  // blocks to build.
  AdvancedSearch.prototype.syncFromLocation = function () {
    var params = new URLSearchParams(window.location.search);
    var gamesParam = params.get('games');
    this.games = gamesParam ? gamesParam.split(',') : [];

    var solo = this.soloGame();
    if (solo) this.games = this.soloTicked(params, solo.code) ? [solo.code] : [];

    this.render();
    this.prefillFromLocation();
  };

  // The one game a store offers, or null. With one game there is no choice to make, so
  // the form shows a quiet checkbox instead of the game step.
  AdvancedSearch.prototype.soloGame = function () {
    var games = this.schema.games || [];
    return games.length === 1 ? games[0] : null;
  };

  AdvancedSearch.prototype.defaultGames = function () {
    var solo = this.soloGame();
    return solo ? [solo.code] : [];
  };

  // Ticked by default, but a URL that is already a search without that game (name and
  // price only) means the shopper unticked it, so it reopens unticked.
  AdvancedSearch.prototype.soloTicked = function (params, code) {
    var searching = !!params.get('q') || !!params.get('games');
    params.forEach(function (value, key) {
      if (value && key.indexOf('.') !== -1) searching = true;
    });
    if (!searching) return true;

    if ((params.get('games') || '').split(',').indexOf(code) !== -1) return true;

    var keys = ((this.schema.game_fields || {})[code] || []).map(function (f) { return f.key; });
    var hit = false;
    params.forEach(function (value, key) {
      if (key.indexOf(code + '.') === 0) hit = true;
    });
    params.getAll('filter.p.tag').forEach(function (raw) {
      var tag = raw.indexOf('instock.') === 0 ? raw.slice('instock.'.length) : raw;
      if (keys.indexOf(tag.split(':')[0]) !== -1) hit = true;
    });
    return hit;
  };

  AdvancedSearch.prototype.render = function () {
    this.renderGames();
    this.renderShared();
    this.renderGameFields();
  };

  AdvancedSearch.prototype.renderGames = function () {
    var self = this;
    var games = this.schema.games || [];

    var solo = this.soloGame();

    this.els.gameStep.hidden = games.length === 0 || !!solo;
    this.els.solo.hidden = !solo;
    this.els.gameGrid.innerHTML = '';
    this.els.solo.innerHTML = '';

    function checkbox(game) {
      var input = document.createElement('input');
      input.type = 'checkbox';
      input.value = game.code;
      input.checked = self.games.indexOf(game.code) !== -1;
      input.addEventListener('change', function () {
        if (input.checked) {
          if (self.games.indexOf(game.code) === -1) self.games.push(game.code);
        } else {
          self.games = self.games.filter(function (c) { return c !== game.code; });
        }
        // Not render(): re-rendering the shared block would wipe what the shopper typed.
        self.renderGameFields();
      });
      return input;
    }

    if (solo) {
      var quiet = document.createElement('label');
      var text = document.createElement('span');
      text.textContent = this.i18n.soloGame.replace('__GAME__', solo.name);
      quiet.appendChild(checkbox(solo));
      quiet.appendChild(text);
      this.els.solo.appendChild(quiet);
      return;
    }

    games.forEach(function (game) {
      var label = document.createElement('label');
      label.className = 'advanced-search__game';

      var span = document.createElement('span');
      span.textContent = game.name;

      label.appendChild(checkbox(game));
      label.appendChild(span);
      self.els.gameGrid.appendChild(label);
    });
  };

  AdvancedSearch.prototype.renderShared = function () {
    var self = this;
    this.els.shared.innerHTML = '';

    (this.schema.shared_fields || []).forEach(function (field) {
      var el = self.buildField(field, null);
      if (el) self.els.shared.appendChild(el);
    });
  };

  AdvancedSearch.prototype.renderGameFields = function () {
    var self = this;
    var byGame = this.schema.game_fields || {};
    var names = {};
    (this.schema.games || []).forEach(function (g) { names[g.code] = g.name; });

    this.els.gameFields.innerHTML = '';

    // A facet tag carries no game, so a facet two ticked games both have is one
    // filter for the whole search. List it once, with every value either game offers.
    var merged = {};
    var order = [];
    this.games.forEach(function (code) {
      (byGame[code] || []).forEach(function (field) {
        if (!self.isFacet(field)) return;
        if (!merged[field.key]) {
          merged[field.key] = { games: 0, field: { key: field.key, label: field.label, control: field.control, values: [] } };
          order.push(field.key);
        }
        var entry = merged[field.key];
        entry.games++;
        if (field.stock_sensitive) entry.field.stock_sensitive = true;
        field.values.forEach(function (v) {
          var have = entry.field.values.find(function (m) { return m.value === v.value; });
          if (!have) {
            entry.field.values.push({ value: v.value, label: v.label, count: v.count });
            return;
          }
          have.count = (have.count || 0) + (v.count || 0);
        });
      });
    });
    var sharedKeys = order.filter(function (key) { return merged[key].games > 1; });

    function block(titleText, fields, game) {
      var list = document.createElement('div');
      list.className = 'advanced-search__fields';
      fields.forEach(function (field) {
        var el = self.buildField(field, game);
        if (el) list.appendChild(el);
      });
      if (!list.children.length) return;

      var section = document.createElement('section');
      section.className = 'advanced-search__game-block';
      if (game) section.dataset.advGame = game;

      var title = document.createElement('h3');
      title.className = 'advanced-search__game-title';
      title.textContent = titleText;
      section.appendChild(title);
      section.appendChild(list);
      self.els.gameFields.appendChild(section);
    }

    block(this.i18n.allGames, sharedKeys.map(function (key) { return merged[key].field; }), null);

    this.games.forEach(function (code) {
      var fields = (byGame[code] || []).filter(function (field) {
        return !(self.isFacet(field) && sharedKeys.indexOf(field.key) !== -1);
      });
      block(names[code] || code.toUpperCase(), fields, code);
    });
  };

  // Facet-backed values always carry a count; format legality's never do.
  AdvancedSearch.prototype.isFacet = function (field) {
    return field.control === 'multi_select' &&
      (field.values || []).some(function (v) { return typeof v.count === 'number'; });
  };

  AdvancedSearch.prototype.buildField = function (field, game) {
    var wrap = document.createElement('div');
    wrap.className = 'adv-field adv-field--' + field.control;
    wrap.setAttribute('data-adv-field', '');
    wrap.dataset.key = field.key;
    wrap.dataset.control = field.control;
    if (game) wrap.dataset.game = game;
    if (field.stock_sensitive) wrap.dataset.stockSensitive = 'true';

    switch (field.control) {
      case 'text': this.buildText(wrap, field); break;
      case 'toggle': this.buildToggle(wrap, field); break;
      case 'range': this.buildRange(wrap, field); break;
      case 'multi_select': return this.buildMultiSelect(wrap, field) ? wrap : null;
      default: return null;
    }
    return wrap;
  };

  AdvancedSearch.prototype.label = function (text, forId) {
    var label = document.createElement('label');
    label.className = 'adv-field__label';
    label.textContent = text;
    if (forId) label.setAttribute('for', forId);
    return label;
  };

  AdvancedSearch.prototype.buildText = function (wrap, field) {
    var id = 'adv-' + (wrap.dataset.game ? wrap.dataset.game + '-' : '') + field.key;
    wrap.appendChild(this.label(field.label, id));

    var input = document.createElement('input');
    input.type = 'text';
    input.id = id;
    input.className = 'adv-field__input';
    input.setAttribute('data-adv-input', '');
    wrap.appendChild(input);
  };

  AdvancedSearch.prototype.buildToggle = function (wrap, field) {
    var label = document.createElement('label');
    label.className = 'adv-field__toggle';

    var input = document.createElement('input');
    input.type = 'checkbox';
    input.setAttribute('data-adv-toggle', '');
    input.checked = field.default_on !== false;

    var span = document.createElement('span');
    span.textContent = field.label;

    label.appendChild(input);
    label.appendChild(span);
    wrap.appendChild(label);
  };

  AdvancedSearch.prototype.buildRange = function (wrap, field) {
    var self = this;
    var text = field.currency ? field.label + ' (' + field.currency.toUpperCase() + ')' : field.label;
    wrap.appendChild(this.label(text));

    var row = document.createElement('div');
    row.className = 'adv-field__range';

    // Price bounds arrive in cents; stat bounds are plain numbers.
    var isPrice = field.key === 'price';
    var bounds = field.values || {};

    function group(labelText, marker) {
      var g = document.createElement('div');
      g.className = 'adv-field__range-group';

      var l = document.createElement('span');
      l.className = 'adv-field__range-label';
      l.textContent = labelText;

      var input = document.createElement('input');
      input.type = 'number';
      input.className = 'adv-field__number';
      input.setAttribute(marker, '');
      input.min = '0';
      if (isPrice) {
        input.step = '0.01';
        input.inputMode = 'decimal';
        if (bounds.min != null) input.placeholder = (bounds.min / 100).toFixed(2);
        if (bounds.max != null && marker === 'data-adv-max') input.placeholder = (bounds.max / 100).toFixed(2);
      } else {
        input.step = '1';
        input.inputMode = 'numeric';
      }

      g.appendChild(l);
      g.appendChild(input);
      return g;
    }

    row.appendChild(group(self.i18n.from, 'data-adv-min'));
    row.appendChild(group(self.i18n.to, 'data-adv-max'));
    wrap.appendChild(row);
  };

  // count === 0 means the store carries none, so drop it. A missing count (format
  // legality, which isn't counted) is not a zero and must still be offered.
  AdvancedSearch.prototype.buildMultiSelect = function (wrap, field) {
    var options = (field.values || []).filter(function (v) { return v.count !== 0; });
    if (!options.length) return false;

    // Format legality has no sidebar facet to read a filter.p.tag back, so it keeps
    // its dotted param.
    if (this.isFacet(field)) wrap.dataset.facet = 'true';

    wrap.appendChild(this.label(field.label));

    var list = document.createElement('div');
    list.className = 'adv-field__options';

    if (options.length > SEARCH_THRESHOLD) {
      var search = document.createElement('input');
      search.type = 'text';
      search.className = 'adv-field__search';
      search.placeholder = this.i18n.optionsSearch;
      search.autocomplete = 'off';
      search.addEventListener('input', function () {
        var q = search.value.toLowerCase().trim();
        list.querySelectorAll('.adv-field__option').forEach(function (option) {
          var hit = q === '' || (option.dataset.label || '').indexOf(q) !== -1;
          option.classList.toggle('is-hidden', !hit);
        });
      });
      wrap.appendChild(search);
    }

    options.forEach(function (option) {
      var label = document.createElement('label');
      label.className = 'adv-field__option';
      label.dataset.label = String(option.label).toLowerCase();

      var input = document.createElement('input');
      input.type = 'checkbox';
      input.setAttribute('data-adv-value', '');
      input.value = option.value;

      var span = document.createElement('span');
      span.textContent = option.label;

      label.appendChild(input);
      label.appendChild(span);
      list.appendChild(label);
    });

    wrap.appendChild(list);
    return true;
  };

  // Fills the just-rendered form from the page's own URL, so the "Advanced search"
  // link on a results page reopens with what the shopper already asked for (a fresh
  // /search with no params has nothing to read here, so this is a no-op there).
  AdvancedSearch.prototype.prefillFromLocation = function () {
    var params = new URLSearchParams(window.location.search);

    // filter.p.tag rides as "[instock.]key:value" (see appendField below); strip the
    // stock-sensitive prefix before matching it back to a field's key.
    var tagValues = params.getAll('filter.p.tag').map(function (raw) {
      var value = raw.indexOf('instock.') === 0 ? raw.slice('instock.'.length) : raw;
      var i = value.indexOf(':');
      return i === -1 ? null : { key: value.slice(0, i), value: value.slice(i + 1) };
    }).filter(Boolean);
    var games = this.games; // the shared list reads each ticked game's dotted param

    this.root.querySelectorAll('[data-adv-field]').forEach(function (wrap) {
      var key = wrap.dataset.key;
      var game = wrap.dataset.game;
      var control = wrap.dataset.control;
      var paramName = game ? game + '.' + key : key;

      if (control === 'text') {
        var value = params.get(paramName);
        if (value) wrap.querySelector('[data-adv-input]').value = value;
        return;
      }

      if (control === 'toggle') {
        // Only the unchecked state is ever written to the URL (see submit()), so a
        // missing param leaves the toggle at its schema default.
        if (params.get('filter.v.availability') === '0,1') {
          wrap.querySelector('[data-adv-toggle]').checked = false;
        }
        return;
      }

      if (control === 'range') {
        var minInput = wrap.querySelector('[data-adv-min]');
        var maxInput = wrap.querySelector('[data-adv-max]');
        if (key === 'price') {
          var gte = params.get('filter.v.price.gte');
          var lte = params.get('filter.v.price.lte');
          if (gte) minInput.value = gte;
          if (lte) maxInput.value = lte;
        } else {
          var min = params.get(game + '.' + key + '_min');
          var max = params.get(game + '.' + key + '_max');
          if (min) minInput.value = min;
          if (max) maxInput.value = max;
        }
        return;
      }

      if (control === 'multi_select') {
        // Tags carry no game; a facet two ticked games share has one list, so a
        // value ticks in one place. A dotted param is still read, for format
        // legality and older links.
        var values = tagValues.filter(function (pair) { return pair.key === key; })
          .map(function (pair) { return pair.value; });
        (game ? [game] : games).forEach(function (g) {
          var raw = params.get(g + '.' + key);
          if (raw) values = values.concat(raw.split(','));
        });
        if (!values.length) return;
        wrap.querySelectorAll('[data-adv-value]').forEach(function (box) {
          if (values.indexOf(box.value) !== -1) box.checked = true;
        });
      }
    });
  };

  AdvancedSearch.prototype.submit = function () {
    var url = new URL(this.searchUrl, window.location.origin);
    var inStock = this.inStockChecked();

    if (this.games.length) url.searchParams.set('games', this.games.join(','));

    var self = this;
    this.root.querySelectorAll('[data-adv-field]').forEach(function (wrap) {
      self.appendField(url, wrap, inStock);
    });

    // The API defaults to in-stock only, so only the unchecked state needs saying.
    if (!inStock) url.searchParams.set('filter.v.availability', '0,1');

    window.location.assign(url.toString());
  };

  AdvancedSearch.prototype.inStockChecked = function () {
    var toggle = this.root.querySelector('[data-adv-field][data-control="toggle"] [data-adv-toggle]');
    return toggle ? toggle.checked : true;
  };

  AdvancedSearch.prototype.appendField = function (url, wrap, inStock) {
    var key = wrap.dataset.key;
    var game = wrap.dataset.game;
    var control = wrap.dataset.control;

    if (control === 'toggle') return; // handled once, in submit()

    if (control === 'text') {
      var value = wrap.querySelector('[data-adv-input]').value.trim();
      if (!value) return;
      url.searchParams.set(game ? game + '.' + key : key, value);
      return;
    }

    if (control === 'range') {
      var min = wrap.querySelector('[data-adv-min]').value;
      var max = wrap.querySelector('[data-adv-max]').value;

      if (key === 'price') {
        // filter.v.price.* is Shopify's own vocabulary, so the search sidebar reads it back.
        if (min !== '') url.searchParams.set('filter.v.price.gte', min);
        if (max !== '') url.searchParams.set('filter.v.price.lte', max);
      } else {
        if (min !== '') url.searchParams.set(game + '.' + key + '_min', min);
        if (max !== '') url.searchParams.set(game + '.' + key + '_max', max);
      }
      return;
    }

    if (control === 'multi_select') {
      var values = [];
      wrap.querySelectorAll('[data-adv-value]:checked').forEach(function (box) {
        values.push(box.value);
      });
      if (!values.length) return;

      if (game && wrap.dataset.facet !== 'true') {
        url.searchParams.set(game + '.' + key, values.join(','));
        return;
      }

      // Facets, shared or per-game, ride as filter.p.tag so the search sidebar reads
      // them back ticked and edits them in place. Stock-sensitive ones (condition,
      // finish) count over inventory, so in the in-stock view they take the `instock.`
      // tag family. Must match the sidebar's rule (SID-373).
      var prefix = (wrap.dataset.stockSensitive === 'true' && inStock) ? 'instock.' : '';
      var existing = url.searchParams.getAll('filter.p.tag');
      values.forEach(function (value) {
        var tag = prefix + key + ':' + value;
        if (existing.indexOf(tag) === -1) {
          url.searchParams.append('filter.p.tag', tag);
          existing.push(tag);
        }
      });
    }
  };

  document.querySelectorAll('[data-advanced-search]').forEach(function (root) {
    new AdvancedSearch(root);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-sort"] && !Shopify.designMode) return;
  try {
    (function() {
  const sortSelect = document.querySelector('[data-sort-select]');
  if (!sortSelect) return;

  sortSelect.addEventListener('change', (e) => {
    const sortValue = e.target.value;

    // Preserve the active filters (read straight off the current URL) and change
    // only the sort. Always set sort_by — including 'manual' — so the Sideboard
    // filtered grid forwards it to /v1/products (manual -> curated collection
    // order). Deleting it would make the API fall back to its default (A-Z), so
    // "Featured" looked like it did nothing.
    const url = new URL(window.location);
    url.searchParams.set('sort_by', sortValue);
    url.searchParams.delete('page'); // a new sort starts at page 1

    // Route through the shared AJAX path so sorting a filtered grid re-fetches the
    // matched + sorted set in place — every other control (filters, pills,
    // pagination) already does this. A full reload was the only reason sorting a
    // filtered collection behaved differently. Fall back to navigation if absent.
    if (typeof window.ajaxFilterUpdate === 'function') {
      window.ajaxFilterUpdate(url.toString());
    } else {
      window.location.href = url.toString();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["currency-selector"] && !Shopify.designMode) return;
  try {
    (function() {
  const selectors = document.querySelectorAll('[data-currency-selector]');
  if (!selectors.length) return;

  selectors.forEach(function(selector) {
    const select = selector.querySelector('[data-currency-select]');
    const form = selector.querySelector('form');
    if (!select || !form) return;

    select.addEventListener('change', function() {
      form.submit();
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["holo-foil"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.HoloFoil) return;

  var fineHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var active = null;
  var activeTilt = 12;
  var raf = 0;
  var pending = null;

  function apply() {
    raf = 0;
    if (!active || !pending) return;
    var rect = active.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    var px = (pending.clientX - rect.left) / rect.width;
    var py = (pending.clientY - rect.top) / rect.height;
    px = px < 0 ? 0 : px > 1 ? 1 : px;
    py = py < 0 ? 0 : py > 1 ? 1 : py;
    active.style.setProperty('--mx', (px * 100).toFixed(2) + '%');
    active.style.setProperty('--my', (py * 100).toFixed(2) + '%');
    active.style.setProperty('--rx', ((px - 0.5) * 2 * activeTilt).toFixed(2) + 'deg');
    active.style.setProperty('--ry', (-(py - 0.5) * 2 * activeTilt).toFixed(2) + 'deg');
  }

  function onMove(e) {
    pending = e;
    if (!raf) raf = requestAnimationFrame(apply);
  }

  function deactivate() {
    if (!active) return;
    active.classList.remove('is-holo-active');
    active.style.removeProperty('--mx');
    active.style.removeProperty('--my');
    active.style.setProperty('--rx', '0deg');
    active.style.setProperty('--ry', '0deg');
    active.removeEventListener('pointermove', onMove);
    active.removeEventListener('pointerleave', deactivate);
    active = null;
  }

  function activate(el) {
    if (active === el) return;
    deactivate();
    active = el;
    var t = parseFloat(getComputedStyle(el).getPropertyValue('--holo-tilt'));
    activeTilt = isNaN(t) ? 12 : t;
    el.classList.add('is-holo-active');
    el.addEventListener('pointermove', onMove);
    el.addEventListener('pointerleave', deactivate);
  }

  if (fineHover && !reduceMotion) {
    document.addEventListener('pointerover', function (e) {
      var el = e.target.closest ? e.target.closest('[data-holo]') : null;
      if (el) activate(el);
    });
  }

  // Foil idle shimmer: tag foils + pause off-screen ones
  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          en.target.classList.toggle('is-holo-paused', !en.isIntersecting);
        });
      }, { rootMargin: '120px' })
    : null;

  function tagFoils(root) {
    var nodes = (root || document).querySelectorAll('[data-holo][data-holo-foil="true"]');
    Array.prototype.forEach.call(nodes, function (el) {
      el.classList.add('holo--foil');
      if (io && !el.__holoObserved) { el.__holoObserved = true; io.observe(el); }
    });
  }

  tagFoils(document);
  // Grid swaps in new cards via the Section Rendering API
  document.addEventListener('collection:updated', function () { tagFoils(document); });

  window.HoloFoil = {
    // Live toggle when a shopper switches the Finish swatch to/from Foil
    setFoil: function (el, isFoil) {
      if (!el) return;
      el.setAttribute('data-holo-foil', isFoil ? 'true' : 'false');
      el.classList.toggle('holo--foil', !!isFoil);
      if (io && isFoil && !el.__holoObserved) { el.__holoObserved = true; io.observe(el); }
    },
    refresh: function (root) { tagFoils(root); }
  };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overflow-controller"] && !Shopify.designMode) return;
  try {
    class OverflowController {
    constructor(root) {
      this.root = root;
      this.mode = root.dataset.overflowMode || 'menu';
      this.itemsBox = root.querySelector('[data-overflow-items]');
      this.moreBox = root.querySelector('[data-overflow-more]');
      this.menu = root.querySelector('[data-overflow-menu]');
      this.toggle = root.querySelector('[data-overflow-toggle]');
      if (!this.itemsBox) return;

      this.items = Array.from(this.itemsBox.children);
      this.gap = this.readGap();
      this.bindMenu();

      this.reflow = this.reflow.bind(this);
      this.ro = new ResizeObserver(this.reflow);
      // Observe the element that actually resizes with the layout AND that we
      // don't mutate. Drop mode's container is content-sized (flex:0 0 auto) and
      // we shrink it by hiding items, so observing it would both miss field
      // resizes and risk a feedback loop — watch the parent field instead. Menu
      // mode's container is stretched to fill its row, so it's the right target.
      this.observed = this.mode === 'drop' && this.root.parentElement
        ? this.root.parentElement
        : this.root;
      this.ro.observe(this.observed);
      // Re-measure once web fonts settle (their width shifts the budget).
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this.reflow);
      }
      this.reflow();
    }

    readGap() {
      const g = parseFloat(getComputedStyle(this.itemsBox).columnGap);
      return Number.isFinite(g) ? g : 0;
    }

    outerWidth(el) {
      return el.getBoundingClientRect().width;
    }

    // Space (px) the parent field must keep for everything that ISN'T chips, so
    // chips fill only the surplus. Computed live: field padding + each flow
    // sibling's minimum (the input's 27ch min-width, the icon's measured width)
    // + the gaps between items. An explicit data-overflow-reserve overrides it.
    dropReserve() {
      const parent = this.root.parentElement;
      if (!parent) return 0;
      const override = parseFloat(this.root.dataset.overflowReserve);
      if (Number.isFinite(override)) return override;

      const ps = getComputedStyle(parent);
      let reserve = (parseFloat(ps.paddingLeft) || 0) + (parseFloat(ps.paddingRight) || 0);
      const gap = parseFloat(ps.columnGap) || 0;
      let flowItems = 1; // the chips strip itself
      Array.from(parent.children).forEach((el) => {
        if (el === this.root) return;
        const es = getComputedStyle(el);
        if (es.position === 'absolute' || es.display === 'none') return;
        flowItems += 1;
        const margin = (parseFloat(es.marginLeft) || 0) + (parseFloat(es.marginRight) || 0);
        const minW = parseFloat(es.minWidth);
        const base = (Number.isFinite(minW) && minW > 0) ? minW : el.getBoundingClientRect().width;
        reserve += base + margin;
      });
      return reserve + gap * (flowItems - 1);
    }

    bindMenu() {
      if (!this.toggle || !this.moreBox) return;
      this.toggle.addEventListener('click', (e) => {
        e.stopPropagation();
        const open = !this.moreBox.classList.contains('is-open');
        this.moreBox.classList.toggle('is-open', open);
        this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', (e) => {
        if (!this.moreBox.contains(e.target)) this.closeMenu();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.closeMenu();
      });
    }

    closeMenu() {
      if (!this.moreBox) return;
      this.moreBox.classList.remove('is-open');
      this.toggle?.setAttribute('aria-expanded', 'false');
    }

    // Build a flattened plain-link version of an item for the More menu.
    toMenuEntry(item) {
      const source = item.querySelector('a, button') || item;
      const label = source.textContent.trim();
      const href = source.getAttribute('href');
      const node = href ? document.createElement('a') : document.createElement('button');
      if (href) {
        node.setAttribute('href', href);
      } else {
        node.setAttribute('type', 'button');
      }
      node.className = 'overflow-menu__link';
      node.textContent = label;
      return node;
    }

    reflow() {
      // Reset to "everything visible" so measurements are truthful.
      this.items.forEach((item) => { item.hidden = false; });
      if (this.menu) this.menu.replaceChildren();
      if (this.moreBox) this.moreBox.hidden = true;

      // Menu mode measures the container itself (it's stretched to fill its
      // row). Drop mode's container shrink-wraps to its content, so it can
      // never report "too wide" — measure the PARENT field instead, minus the
      // space its non-chip pieces need. That reserve is computed live (no magic
      // number): the field's padding, each flow sibling's minimum (the search
      // input's 27ch min-width — Nielsen's readable floor — and the icon's
      // width), and the gaps between them. So chips yield to a readable input.
      let available;
      if (this.mode === 'drop' && this.root.parentElement) {
        available = this.root.parentElement.clientWidth - this.dropReserve();
      } else {
        available = this.root.clientWidth;
      }
      const widths = this.items.map((item) => this.outerWidth(item));
      // Content width = the items plus the gaps *between* them (n - 1 gaps).
      const gaps = Math.max(0, this.items.length - 1) * this.gap;
      const total = widths.reduce((a, b) => a + b, 0) + gaps;

      // Fits (with a sub-pixel tolerance) — leave the row untouched, no More.
      if (total <= available + 1) {
        this.closeMenu();
        return;
      }

      // Overflow needed. In menu mode, reserve room for the More control.
      let moreWidth = 0;
      if (this.mode === 'menu' && this.moreBox) {
        this.moreBox.hidden = false;
        moreWidth = this.outerWidth(this.moreBox) + this.gap;
      }

      const budget = available - moreWidth;
      let used = 0;
      let cut = this.items.length;
      for (let i = 0; i < this.items.length; i++) {
        used += widths[i];
        if (i > 0) used += this.gap;
        if (used > budget) { cut = i; break; }
      }
      // Menu mode keeps at least the first item beside More; drop mode may hide
      // every item when there's genuinely no room (e.g. a very narrow field).
      if (this.mode === 'menu' && cut < 1) cut = 1;

      const overflowing = this.items.slice(cut);

      // Nothing actually spilled — don't strand an empty More button.
      if (overflowing.length === 0) {
        if (this.moreBox) this.moreBox.hidden = true;
        this.closeMenu();
        return;
      }

      overflowing.forEach((item) => {
        item.hidden = true;
        if (this.mode === 'menu' && this.menu) {
          this.menu.appendChild(this.toMenuEntry(item));
        }
      });
    }

    destroy() {
      this.ro?.disconnect();
    }
  }

  function initOverflow(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-overflow]').forEach((el) => {
      if (!el.__overflow) el.__overflow = new OverflowController(el);
    });
  }

  // Shopify bundles javascript-tag content and runs it after the DOM is parsed, so a
  // DOMContentLoaded listener added here would never fire — run init now if the
  // document is already ready, otherwise wait for the event.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initOverflow());
  } else {
    initOverflow();
  }
  // Theme editor: re-init the section that just (re)loaded.
  document.addEventListener('shopify:section:load', (e) => initOverflow(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('[data-overflow]').forEach((el) => {
      el.__overflow?.destroy();
      el.__overflow = null;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    (function() {
  const DEBOUNCE_MS = 200;
  const STORAGE_KEY = 'sideboard_recent_searches';
  const MAX_RECENT = 5;
  const SUGGEST_MIN_LENGTH = 3;
  const SUGGEST_TIMEOUT_MS = 3000;

  /**
   * Escapes HTML entities to prevent XSS
   */
  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.textContent;
  }

  /**
   * Creates a text node with highlighted search matches
   * Returns a document fragment with text and mark elements
   */
  function createHighlightedText(text, query) {
    const fragment = document.createDocumentFragment();
    if (!query) {
      fragment.appendChild(document.createTextNode(text));
      return fragment;
    }

    const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    const parts = text.split(regex);

    parts.forEach(part => {
      if (part.toLowerCase() === query.toLowerCase()) {
        const mark = document.createElement('mark');
        mark.textContent = part;
        fragment.appendChild(mark);
      } else if (part) {
        fragment.appendChild(document.createTextNode(part));
      }
    });

    return fragment;
  }

  /**
   * Creates an SVG element with safe DOM methods
   */
  function createSvgIcon(pathD, viewBox = '0 0 12 12') {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', viewBox);
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', pathD);
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.5');
    path.setAttribute('stroke-linecap', 'round');
    svg.appendChild(path);
    return svg;
  }

  class PredictiveSearch {
    constructor(container) {
      this.container = container;
      this.input = container.querySelector('[data-predictive-search-input]');
      this.results = container.querySelector('[data-predictive-search-results]');
      this.spinner = container.querySelector('[data-predictive-search-spinner]');
      this.filters = container.querySelector('[data-predictive-search-filters]');
      this.chipsContainer = container.querySelector('[data-predictive-search-chips]');

      // Config from data attributes
      this.maxResults = parseInt(container.dataset.maxResults, 10) || 6;
      this.searchUrl = container.dataset.searchUrl || '/search';
      // Present only when the theme's Search source is Sideboard.
      this.suggestUrl = container.dataset.suggestUrl || '';

      // Filter style: 'pills' or 'chips'
      this.filterStyle = container.dataset.filterStyle || 'pills';

      // Parse available filter labels
      this.filterLabels = [];
      if (this.filters?.dataset.filterLabels) {
        this.filterLabels = this.filters.dataset.filterLabels.split(',').map(f => f.trim()).filter(Boolean);
      }

      // Result sections
      this.filterSuggestionsSection = container.querySelector('[data-predictive-search-filter-suggestions]');
      this.filterSuggestionsList = container.querySelector('[data-predictive-search-filter-list]');
      this.recentSection = container.querySelector('[data-predictive-search-recent]');
      this.recentList = container.querySelector('[data-predictive-search-recent-list]');
      this.liveSection = container.querySelector('[data-predictive-search-live]');
      this.productList = container.querySelector('[data-predictive-search-product-list]');
      this.collectionsSection = container.querySelector('[data-predictive-search-collections]');
      this.collectionList = container.querySelector('[data-predictive-search-collection-list]');
      this.noResults = container.querySelector('[data-predictive-search-no-results]');
      this.viewAllLink = container.querySelector('[data-predictive-search-view-all]');
      this.countEl = container.querySelector('[data-predictive-search-count]');
      this.clearRecentBtn = container.querySelector('[data-predictive-search-clear-recent]');

      this.debounceTimer = null;
      this.abortController = null;
      this.selectedIndex = -1;
      // For chips mode, support multiple active filters
      this.activeFilters = [];
      // For pills mode (legacy single filter)
      this.activeFilter = null;
      this.cache = new Map();
      // handle -> { price, compare, available } from the server-rendered price section
      this.priceMap = {};

      this.form = container.querySelector('form');
      this.scopeEl = container.querySelector('[data-predictive-search-scope]');
      this.scopeBox = container.querySelector('[data-predictive-search-scope-input]');

      this.bindEvents();
      if (this.scopeEl) {
        // The collection content sits after the header, so wait for the full document.
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initScope());
        } else {
          this.initScope();
        }
      }
    }

    initScope() {
      const marker = document.querySelector('[data-search-scope-url]');
      if (!marker) return;
      this.scopeUrl = marker.dataset.searchScopeUrl;
      this.scopeId = marker.dataset.searchScopeId;
      this.scopeEl.querySelector('[data-predictive-search-scope-label]').textContent =
        this.scopeEl.dataset.label.replace('%collection%', () => marker.dataset.searchScopeTitle);
      this.scopeEl.hidden = false;
      this.scopeBox.addEventListener('change', () => this.applyScope());
      this.applyScope();
    }

    isScoped() {
      return !!this.scopeEl && !this.scopeEl.hidden && this.scopeBox.checked;
    }

    // Scoped: the plain form submit lands on the collection page, whose own grid
    // reads q, and the suggestions are limited to that collection.
    applyScope() {
      this.form.action = this.isScoped() ? this.scopeUrl : this.searchUrl;
      if (this.input.value.trim()) this.onInput();
    }

    bindEvents() {
      // Input events
      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('focus', () => this.onFocus());
      this.input.addEventListener('keydown', (e) => this.onKeydown(e));

      // Clear recent
      this.clearRecentBtn?.addEventListener('click', () => this.clearRecent());

      // Filter pills (only in pills mode)
      if (this.filterStyle === 'pills') {
        this.filters?.querySelectorAll('[data-filter]').forEach(btn => {
          btn.addEventListener('click', () => this.onFilterClick(btn));
        });
      }

      // Quick-filter chips rendered inside the field (chips mode). Trailing
      // chips are hidden by the overflow-controller; the visible ones apply a
      // single filter the same way a pill does.
      this.quickChips = this.container.querySelector('.predictive-search__quickchips');
      this.quickChips?.querySelectorAll('[data-filter]').forEach(btn => {
        btn.addEventListener('click', () => this.onQuickChipClick(btn));
      });

      // Click outside to close
      document.addEventListener('click', (e) => {
        if (!this.container.contains(e.target)) {
          this.close();
        }
      });

      // Escape to close
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.close();
          this.input.blur();
        }
      });

      // Result click - save to recent
      this.results.addEventListener('click', (e) => {
        const link = e.target.closest('a');
        if (link && this.input.value.trim()) {
          this.saveRecent(this.input.value.trim());
        }
      });
    }

    onInput() {
      const query = this.input.value.trim();

      // Debounce the search
      clearTimeout(this.debounceTimer);

      if (!query && this.activeFilters.length === 0) {
        this.hideFilterSuggestions();
        this.showRecent();
        return;
      }

      // Check for typeahead filter matches
      this.updateFilterSuggestions(query);

      this.debounceTimer = setTimeout(() => {
        if (query || this.activeFilters.length > 0) {
          this.search(query);
        }
      }, DEBOUNCE_MS);
    }

    onFocus() {
      if (!this.input.value.trim() && this.activeFilters.length === 0) {
        this.showRecent();
      } else {
        this.open();
      }
    }

    onKeydown(e) {
      // Handle backspace to remove last chip in chips mode
      if (this.filterStyle === 'chips' && e.key === 'Backspace' && !this.input.value && this.activeFilters.length > 0) {
        e.preventDefault();
        this.removeFilter(this.activeFilters[this.activeFilters.length - 1]);
        return;
      }

      if (!this.isOpen()) return;

      const items = this.getNavigableItems();
      if (!items.length) return;

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          this.selectedIndex = Math.min(this.selectedIndex + 1, items.length - 1);
          this.updateSelection(items);
          break;
        case 'ArrowUp':
          e.preventDefault();
          this.selectedIndex = Math.max(this.selectedIndex - 1, -1);
          this.updateSelection(items);
          break;
        case 'Enter':
          if (this.selectedIndex >= 0 && items[this.selectedIndex]) {
            e.preventDefault();
            items[this.selectedIndex].click();
          }
          break;
      }
    }

    onFilterClick(btn) {
      const filter = btn.dataset.filter;

      // Toggle filter (pills mode - single filter)
      if (this.activeFilter === filter) {
        this.activeFilter = null;
        btn.classList.remove('predictive-search__filter--active');
      } else {
        // Remove active from all
        this.filters.querySelectorAll('[data-filter]').forEach(b => {
          b.classList.remove('predictive-search__filter--active');
        });
        this.activeFilter = filter;
        btn.classList.add('predictive-search__filter--active');
      }

      // Re-search if there's a query
      const query = this.input.value.trim();
      if (query) {
        this.search(query);
      }

      this.input.focus();
    }

    onQuickChipClick(btn) {
      const filter = btn.dataset.filter;
      const isActive = this.activeFilter === filter;

      // Single-select: clear every quick chip, then set the clicked one.
      this.quickChips?.querySelectorAll('[data-filter]').forEach(b => {
        b.classList.remove('predictive-search__chip--active');
      });

      if (isActive) {
        this.activeFilter = null;
      } else {
        this.activeFilter = filter;
        btn.classList.add('predictive-search__chip--active');
      }

      const query = this.input.value.trim();
      if (query) this.search(query);
      this.input.focus();
    }

    // Typeahead filter suggestions
    updateFilterSuggestions(query) {
      if (!this.filterSuggestionsSection || !query) {
        this.hideFilterSuggestions();
        return;
      }

      const queryLower = query.toLowerCase();
      const matches = this.filterLabels.filter(label => {
        // Match if filter starts with query, and not already active
        const labelLower = label.toLowerCase();
        const isActive = this.filterStyle === 'chips'
          ? this.activeFilters.includes(label)
          : this.activeFilter === label;
        return labelLower.startsWith(queryLower) && !isActive;
      });

      if (matches.length === 0) {
        this.hideFilterSuggestions();
        return;
      }

      // Render filter suggestions
      this.filterSuggestionsList.replaceChildren();
      matches.forEach((filterLabel, i) => {
        const li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        li.dataset.index = i;
        li.dataset.filterSuggestion = filterLabel;

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'predictive-search__filter-suggestion-item';

        // Filter icon using safe DOM methods
        const svg = createSvgIcon('M3 5h14M5 10h10M7 15h6', '0 0 20 20');
        btn.appendChild(svg);

        const span = document.createElement('span');
        span.appendChild(createHighlightedText(filterLabel, query));
        btn.appendChild(span);

        const hint = document.createElement('span');
        hint.className = 'predictive-search__filter-hint';
        hint.textContent = 'Filter';
        btn.appendChild(hint);

        btn.addEventListener('click', () => {
          this.applyFilterFromSuggestion(filterLabel);
        });

        li.appendChild(btn);
        this.filterSuggestionsList.appendChild(li);
      });

      this.filterSuggestionsSection.hidden = false;
    }

    hideFilterSuggestions() {
      if (this.filterSuggestionsSection) {
        this.filterSuggestionsSection.hidden = true;
      }
    }

    applyFilterFromSuggestion(filterLabel) {
      // Clear the typed text that matched the filter
      this.input.value = '';

      if (this.filterStyle === 'chips') {
        // Add as chip
        this.addFilter(filterLabel);
      } else {
        // Pills mode - activate the pill
        this.activeFilter = filterLabel;
        this.filters?.querySelectorAll('[data-filter]').forEach(btn => {
          if (btn.dataset.filter === filterLabel) {
            btn.classList.add('predictive-search__filter--active');
          } else {
            btn.classList.remove('predictive-search__filter--active');
          }
        });
      }

      this.hideFilterSuggestions();
      this.input.focus();

      // Search with filter applied
      this.search('');
    }

    // Chips mode: add filter
    addFilter(filterLabel) {
      if (this.activeFilters.includes(filterLabel)) return;

      this.activeFilters.push(filterLabel);
      this.renderChips();
    }

    // Chips mode: remove filter
    removeFilter(filterLabel) {
      this.activeFilters = this.activeFilters.filter(f => f !== filterLabel);
      this.renderChips();

      // Re-search
      const query = this.input.value.trim();
      if (query || this.activeFilters.length > 0) {
        this.search(query);
      } else {
        this.showRecent();
      }

      this.input.focus();
    }

    // Render chips inside input using safe DOM methods
    renderChips() {
      if (!this.chipsContainer) return;

      this.chipsContainer.replaceChildren();

      if (this.activeFilters.length === 0) {
        this.chipsContainer.hidden = true;
        this.container.classList.remove('predictive-search--has-chips');
        return;
      }

      this.activeFilters.forEach(filter => {
        const chip = document.createElement('span');
        chip.className = 'predictive-search__chip';
        chip.dataset.chip = filter;

        const label = document.createElement('span');
        label.className = 'predictive-search__chip-label';
        label.textContent = filter;
        chip.appendChild(label);

        const removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'predictive-search__chip-remove';
        removeBtn.setAttribute('aria-label', `Remove ${filter} filter`);
        // Use safe DOM methods for the X icon
        const xIcon = createSvgIcon('M3 3l6 6M9 3l-6 6');
        removeBtn.appendChild(xIcon);
        removeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.removeFilter(filter);
        });
        chip.appendChild(removeBtn);

        this.chipsContainer.appendChild(chip);
      });

      this.chipsContainer.hidden = false;
      this.container.classList.add('predictive-search--has-chips');
    }

    async search(query) {
      // Build search query with filters
      let searchQuery = query;

      if (this.filterStyle === 'chips' && this.activeFilters.length > 0) {
        // Append all active filters
        searchQuery = [query, ...this.activeFilters].filter(Boolean).join(' ');
      } else if (this.activeFilter) {
        searchQuery = `${query} ${this.activeFilter}`;
      }

      // If nothing to search
      if (!searchQuery.trim()) {
        this.hideFilterSuggestions();
        this.showRecent();
        return;
      }

      const scopeId = this.isScoped() ? this.scopeId : '';

      // The suggest endpoint answers empty under 3 characters.
      if (this.suggestUrl && searchQuery.trim().length < SUGGEST_MIN_LENGTH) {
        this.close();
        return;
      }

      // Check cache
      const cacheKey = `${scopeId}|${searchQuery.toLowerCase()}`;
      if (this.cache.has(cacheKey)) {
        const cached = this.cache.get(cacheKey);
        this.priceMap = cached.priceMap || {};
        this.renderResults(cached.data, query);
        return;
      }

      // Cancel previous request
      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();

      // Show spinner
      if (this.spinner) {
        this.spinner.hidden = false;
      }

      try {
        const signal = this.abortController.signal;
        if (this.suggestUrl) {
          // Any failure or timeout here means Shopify answers this request instead.
          try {
            const { data, priceMap } = await this.fetchSideboard(searchQuery, scopeId, signal);
            this.priceMap = priceMap;
            this.cache.set(cacheKey, { data, priceMap });
            this.renderResults(data, query);
            return;
          } catch (e) {
            if (signal.aborted) throw e;
            // A ticked box must never show results from outside the collection, and
            // Shopify's suggestions are site-wide, so show none.
            if (scopeId) {
              this.close();
              return;
            }
          }
        }

        // The /search/suggest.json payload has no variants, so its product.price is
        // price_min — a phantom $0 for TCG products with $0 out-of-stock conditions.
        // Fetch the correct cheapest-in-stock-variant prices in parallel from a
        // server-rendered section (full Liquid variant access), keyed by handle.
        const [response, pricesRes] = await Promise.all([
          fetch(
            `/search/suggest.json?q=${encodeURIComponent(searchQuery)}&resources[type]=product,collection&resources[limit]=${this.maxResults}&resources[options][unavailable_products]=last`,
            { signal: this.abortController.signal }
          ),
          fetch(
            `/search/suggest?q=${encodeURIComponent(searchQuery)}&section_id=predictive-search-prices&resources[type]=product&resources[limit]=${this.maxResults}&resources[options][unavailable_products]=last`,
            { signal: this.abortController.signal }
          ).catch(() => null)
        ]);

        if (!response.ok) throw new Error('Search failed');

        const data = await response.json();

        let priceMap = {};
        if (pricesRes && pricesRes.ok) {
          try { priceMap = this.parsePriceMap(await pricesRes.text()); } catch (e) {}
        }
        this.priceMap = priceMap;

        // Cache results (with the server-rendered price map)
        this.cache.set(cacheKey, { data, priceMap });

        this.renderResults(data, query);
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('Predictive search error:', err);
        }
      } finally {
        if (this.spinner) {
          this.spinner.hidden = true;
        }
      }
    }

    // Returns the /search/suggest.json shape plus the price map, built from the
    // suggest rows alone (one request per keystroke). Only rows with no catalogue
    // image (store products Sideboard does not own) fetch one.
    async fetchSideboard(searchQuery, scopeId, signal) {
      const timeout = new AbortController();
      const timer = setTimeout(() => timeout.abort(), SUGGEST_TIMEOUT_MS);
      const stop = () => timeout.abort();
      signal.addEventListener('abort', stop);
      try {
        const url = new URL(this.suggestUrl, window.location.origin);
        url.searchParams.set('q', searchQuery);
        url.searchParams.set('include_out_of_stock', '1');
        if (scopeId) url.searchParams.set('collection_id', scopeId);
        const res = await fetch(url, { signal: timeout.signal });
        if (!res.ok) throw new Error('Suggest failed');
        const body = await res.json();
        if (!body.success) throw new Error('Suggest failed');

        const priceMap = {};
        const products = await Promise.all(body.products.slice(0, this.maxResults).map(async (p) => {
          let image = p.image_url;
          if (!image) {
            image = await fetch(`/products/${encodeURIComponent(p.handle)}.js`, { signal: timeout.signal })
              .then((r) => (r.ok ? r.json() : null))
              .then((j) => (j && j.featured_image) || null)
              .catch(() => null);
          }
          // price.amount is in price.currency, which can differ from the shopper's active
          // currency under Markets, so the row carries it. The map holds cents like the
          // Shopify path. A null price renders no price line.
          const setLine = [p.set_name, p.collector_number && `#${p.collector_number}`].filter(Boolean).join(' · ');
          priceMap[p.handle] = {
            price: p.price ? Math.round(p.price.amount * 100) : null,
            compare: 0,
            currency: p.price && p.price.currency,
            available: !!(p.price && p.price.in_stock),
            isSingle: !!p.set_name,
            set: setLine
          };
          return { handle: p.handle, title: p.title, url: p.url, image };
        }));

        return {
          data: { resources: { results: { products, collections: body.collections.slice(0, this.maxResults) } } },
          priceMap
        };
      } finally {
        clearTimeout(timer);
        signal.removeEventListener('abort', stop);
      }
    }

    renderResults(data, query) {
      const products = data.resources?.results?.products || [];
      const collections = data.resources?.results?.collections || [];
      const hasResults = products.length > 0 || collections.length > 0;

      // Hide filter suggestions & recent, show live
      this.hideFilterSuggestions();
      if (this.recentSection) this.recentSection.hidden = true;
      this.liveSection.hidden = !hasResults;
      this.noResults.hidden = hasResults;

      if (!hasResults) {
        this.open();
        return;
      }

      // Clear and render products using safe DOM methods
      this.productList.replaceChildren();
      products.forEach((product, i) => {
        this.productList.appendChild(this.createProductElement(product, i, query));
      });

      // Render collections
      if (collections.length > 0) {
        this.collectionsSection.hidden = false;
        this.collectionList.replaceChildren();
        collections.forEach((collection, i) => {
          this.collectionList.appendChild(this.createCollectionElement(collection, products.length + i, query));
        });
      } else {
        this.collectionsSection.hidden = true;
      }

      // Update view all link
      let fullQuery = query;
      if (this.filterStyle === 'chips' && this.activeFilters.length > 0) {
        fullQuery = [query, ...this.activeFilters].filter(Boolean).join(' ');
      } else if (this.activeFilter) {
        fullQuery = `${query} ${this.activeFilter}`;
      }
      // 0,1, matching the hidden form field above: a search that only turns up
      // sold-out listings must still land on results.
      this.viewAllLink.href = `${this.isScoped() ? this.scopeUrl : this.searchUrl}?q=${encodeURIComponent(fullQuery)}&filter.v.availability=0,1`;
      if (this.countEl) {
        this.countEl.textContent = `(${products.length}+)`;
      }

      this.selectedIndex = -1;
      this.open();
    }

    createProductElement(product, index, query) {
      const li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      li.dataset.index = index;

      const link = document.createElement('a');
      link.href = product.url;
      link.className = 'predictive-search__item predictive-search__product';

      // Price map entry, fetched in parallel and awaited before this ever runs, so
      // this lookup and the price one below share it. suggest.json carries no
      // product type; this rides along with the same server-rendered map as price/set.
      const priced = this.priceMap && this.priceMap[product.handle];

      // Image container
      const imageDiv = document.createElement('div');
      imageDiv.className = 'predictive-search__product-image';
      // Sealed product, ETBs, and merch aren't cropped to the TCG card ratio; a
      // missing map entry (parallel price fetch failed) falls back to cropped,
      // matching prior behavior instead of guessing.
      if (priced && priced.isSingle === false) {
        imageDiv.classList.add('predictive-search__product-image--contain');
      }
      const imageUrl = product.image || product.featured_image?.url;
      if (imageUrl) {
        const img = document.createElement('img');
        // Width-only sizing keeps the card's native portrait ratio (no square
        // crop); the CSS box frames it to a 5:7 card shape.
        img.src = this.getSizedImageUrl(imageUrl, '160x');
        img.alt = '';
        img.loading = 'lazy';
        imageDiv.appendChild(img);
      } else {
        // No synced image: show an "image" glyph so the card reads as "no
        // image" rather than a flat colored square that vanishes on the highlight.
        imageDiv.classList.add('predictive-search__product-image--placeholder');
        const svgNS = 'http://www.w3.org/2000/svg';
        const svg = document.createElementNS(svgNS, 'svg');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('fill', 'none');
        svg.setAttribute('aria-hidden', 'true');
        const mk = (tag, attrs) => {
          const el = document.createElementNS(svgNS, tag);
          for (const key in attrs) el.setAttribute(key, attrs[key]);
          el.setAttribute('stroke', 'currentColor');
          el.setAttribute('stroke-width', '1.5');
          return el;
        };
        svg.appendChild(mk('rect', { x: 3, y: 3, width: 18, height: 18, rx: 2 }));
        svg.appendChild(mk('circle', { cx: 8.5, cy: 8.5, r: 1.5 }));
        svg.appendChild(mk('path', { d: 'm21 15-5-5L5 21', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' }));
        imageDiv.appendChild(svg);
      }
      link.appendChild(imageDiv);

      // Info container
      const infoDiv = document.createElement('div');
      infoDiv.className = 'predictive-search__product-info';

      // Title with highlighting
      const titleSpan = document.createElement('span');
      titleSpan.className = 'predictive-search__product-title';
      titleSpan.appendChild(createHighlightedText(product.title, query));
      infoDiv.appendChild(titleSpan);

      // Vendor
      if (product.vendor) {
        const vendorSpan = document.createElement('span');
        vendorSpan.className = 'predictive-search__product-vendor';
        vendorSpan.textContent = product.vendor;
        infoDiv.appendChild(vendorSpan);
      }

      // Set (TCG expansion) — only when the server-rendered map carries one.
      // suggest.json has no metafields, so this comes from the price section.
      const setName = this.priceMap?.[product.handle]?.set;
      if (setName) {
        const setSpan = document.createElement('span');
        setSpan.className = 'predictive-search__product-set';
        setSpan.textContent = setName;
        infoDiv.appendChild(setSpan);
      }

      // Price
      const priceSpan = document.createElement('span');
      priceSpan.className = 'predictive-search__product-price';

      // product.price is price_min; TCG out-of-stock conditions sit at $0, so it can be a
      // phantom $0 (and compare_at_price_max > 0 would flag a false sale). The suggest.json
      // payload has no variants, so prefer the server-rendered cheapest-in-stock-variant
      // price keyed by handle (parsePriceMap / sections/predictive-search-prices.liquid).
      // Fall back to in-payload variants, then product.price, if the map is unavailable.
      let displayPrice = product.price;
      let displayCompare = product.compare_at_price_max;
      let displayAvailable = product.available;
      if (priced) {
        displayPrice = priced.price;
        displayCompare = priced.compare;
        displayAvailable = priced.available;
      } else if (Array.isArray(product.variants) && product.variants.length) {
        let cheapest = null;
        for (const v of product.variants) {
          if (v.available && v.price > 0 && (cheapest === null || v.price < cheapest.price)) {
            cheapest = v;
          }
        }
        if (cheapest) {
          displayPrice = cheapest.price;
          displayCompare = cheapest.compare_at_price;
        }
      }

      const comparePrice = displayCompare > displayPrice
        ? this.formatMoney(displayCompare)
        : null;

      if (comparePrice) {
        const compareEl = document.createElement('s');
        compareEl.className = 'predictive-search__compare-price';
        compareEl.textContent = comparePrice;
        priceSpan.appendChild(compareEl);
      }

      // Sideboard rows with no real price carry null; show no price line for them.
      const hasPrice = displayPrice != null;
      if (hasPrice) {
        const currentPrice = document.createElement('span');
        if (comparePrice) currentPrice.className = 'predictive-search__sale-price';
        currentPrice.textContent = this.formatMoney(displayPrice, priced && priced.currency);
        priceSpan.appendChild(currentPrice);
      }

      if (hasPrice && !displayAvailable) {
        const soldOut = document.createElement('span');
        soldOut.className = 'predictive-search__sold-out';
        soldOut.textContent = 'Sold out';
        priceSpan.appendChild(soldOut);
      }

      infoDiv.appendChild(priceSpan);
      link.appendChild(infoDiv);
      li.appendChild(link);

      return li;
    }

    createCollectionElement(collection, index, query) {
      const li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      li.dataset.index = index;

      const link = document.createElement('a');
      link.href = collection.url;
      link.className = 'predictive-search__item predictive-search__collection';

      const titleSpan = document.createElement('span');
      titleSpan.appendChild(createHighlightedText(collection.title, query));
      link.appendChild(titleSpan);

      // Arrow icon
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 20 20');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('aria-hidden', 'true');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M7 4l6 6-6 6');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.5');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      svg.appendChild(path);
      link.appendChild(svg);

      li.appendChild(link);
      return li;
    }

    formatMoney(cents, currency) {
      // Simple money formatting - adjust based on store settings
      // Same Intl formatting as collection-filters.liquid, so the dropdown reads like
      // the cards ("$2.50", "CA$2.50").
      const amount = cents / 100;
      const code = currency || window.Shopify?.currency?.active;
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: code.toUpperCase() }).format(amount);
      } catch (e) {
        return `$${amount.toFixed(2)}`;
      }
    }

    getSizedImageUrl(url, size) {
      if (!url) return '';
      // Shopify image URL sizing
      return url.replace(/(\.[^.]+)$/, `_${size}$1`);
    }

    // Parse the server-rendered predictive-search-prices section into a
    // { handle: { price, compare, available } } map (prices in cents).
    parsePriceMap(html) {
      const map = {};
      const doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('[data-handle]').forEach((el) => {
        map[el.getAttribute('data-handle')] = {
          price: parseInt(el.getAttribute('data-price'), 10) || 0,
          compare: parseInt(el.getAttribute('data-compare'), 10) || 0,
          available: el.getAttribute('data-available') === 'true',
          // Only present when the product has a tcg.set_name metafield; absent
          // otherwise so the tile knows to skip the set line entirely.
          set: el.getAttribute('data-set') || '',
          isSingle: el.getAttribute('data-is-single') === 'true'
        };
      });
      return map;
    }

    // Recent searches
    showRecent() {
      if (!this.recentSection) {
        this.close();
        return;
      }

      const recent = this.getRecent();
      if (!recent.length) {
        this.close();
        return;
      }

      this.liveSection.hidden = true;
      this.noResults.hidden = true;
      this.recentSection.hidden = false;

      // Clear and rebuild using safe DOM methods
      this.recentList.replaceChildren();
      recent.forEach((term, i) => {
        const li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        li.dataset.index = i;

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'predictive-search__recent-item';
        btn.dataset.recentTerm = term;

        // Clock icon
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 20 20');
        svg.setAttribute('fill', 'none');
        svg.setAttribute('aria-hidden', 'true');
        const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        circle.setAttribute('cx', '10');
        circle.setAttribute('cy', '10');
        circle.setAttribute('r', '7');
        circle.setAttribute('stroke', 'currentColor');
        circle.setAttribute('stroke-width', '1.5');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M10 6v4l2.5 2.5');
        path.setAttribute('stroke', 'currentColor');
        path.setAttribute('stroke-width', '1.5');
        path.setAttribute('stroke-linecap', 'round');
        svg.appendChild(circle);
        svg.appendChild(path);
        btn.appendChild(svg);

        const span = document.createElement('span');
        span.textContent = term;
        btn.appendChild(span);

        btn.addEventListener('click', () => {
          this.input.value = term;
          this.search(term);
        });

        li.appendChild(btn);
        this.recentList.appendChild(li);
      });

      this.selectedIndex = -1;
      this.open();
    }

    getRecent() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch {
        return [];
      }
    }

    saveRecent(term) {
      try {
        let recent = this.getRecent();
        // Remove if exists, add to front
        recent = recent.filter(t => t.toLowerCase() !== term.toLowerCase());
        recent.unshift(term);
        // Limit
        recent = recent.slice(0, MAX_RECENT);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(recent));
      } catch {
        // localStorage unavailable
      }
    }

    clearRecent() {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch {}
      this.close();
    }

    // Navigation
    getNavigableItems() {
      return Array.from(this.results.querySelectorAll('[role="option"]:not([hidden]) a, [role="option"]:not([hidden]) button'));
    }

    updateSelection(items) {
      // Remove previous selection
      this.results.querySelectorAll('[aria-selected="true"]').forEach(el => {
        el.setAttribute('aria-selected', 'false');
      });

      if (this.selectedIndex >= 0 && items[this.selectedIndex]) {
        const item = items[this.selectedIndex];
        const li = item.closest('[role="option"]');
        if (li) {
          li.setAttribute('aria-selected', 'true');
          item.scrollIntoView({ block: 'nearest' });
        }
      }
    }

    // Open/close
    open() {
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.container.classList.add('predictive-search--open');
    }

    close() {
      this.results.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.container.classList.remove('predictive-search--open');
      this.selectedIndex = -1;
    }

    isOpen() {
      return !this.results.hidden;
    }

  }

  // Initialize all predictive search instances
  document.querySelectorAll('[data-predictive-search]').forEach(container => {
    new PredictiveSearch(container);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-list"] && !Shopify.designMode) return;
  try {
    (function() {
  // Format money using Shopify's formatter or fallback, matching the pre-cascade inline
  // check this replaces. Guarded the same way snippets/cart-api.liquid does, so a page
  // where window.Shopify hasn't loaded yet can't throw here.
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // Bind one list card's interactive controls. Guarded so a card is never bound twice.
  function initCard(card) {
    if (card.dataset.cardInit) return;
    var form = card.querySelector('[data-list-form]');
    if (!form) return;
    card.dataset.cardInit = 'true';

    var variantInput = form.querySelector('[data-list-variant-id]');
    var qtyInput = form.querySelector('[data-list-qty-input]');
    var decreaseBtn = form.querySelector('[data-list-qty-decrease]');
    var increaseBtn = form.querySelector('[data-list-qty-increase]');
    var addBtn = form.querySelector('[data-list-add-btn]');
    var playsetBtn = form.querySelector('[data-list-playset-add]');
    var priceEl = card.querySelector('[data-list-price]');
    var priceMobileEl = card.querySelector('[data-list-price-mobile]');
    var stockEl = card.querySelector('[data-list-stock]');
    var stockMobileEl = card.querySelector('[data-list-stock-mobile]');
    var variantsJson = card.querySelector('[data-list-variants]');

    var variants = [];
    if (variantsJson) {
      try {
        variants = JSON.parse(variantsJson.textContent);
      } catch (e) {
        console.error('Failed to parse variants:', e);
      }
    }

    // Quantity controls with input validation
    if (decreaseBtn && qtyInput) {
      decreaseBtn.addEventListener('click', function() {
        var current = parseInt(qtyInput.value) || 1;
        var max = parseInt(qtyInput.max) || 99;
        var qty = Math.max(1, Math.min(current - 1, max));
        qtyInput.value = qty;
      });
    }

    if (increaseBtn && qtyInput) {
      increaseBtn.addEventListener('click', function() {
        var current = parseInt(qtyInput.value) || 1;
        var max = parseInt(qtyInput.max) || 99;
        var qty = Math.max(1, Math.min(current + 1, max));
        qtyInput.value = qty;
      });
    }

    // Validate quantity on direct input
    if (qtyInput) {
      qtyInput.addEventListener('change', function() {
        var max = parseInt(qtyInput.max) || 99;
        var qty = Math.max(1, Math.min(parseInt(qtyInput.value) || 1, max));
        qtyInput.value = qty;
      });
    }

    // Option selection - cascading variant resolution, ported from product-card.liquid's
    // "select down" pattern: a group only constrains the groups rendered BELOW it, never
    // the groups above. Every option control (radio swatch, fallback <select>, or hidden
    // input for a single-value option) carries data-list-option-control and is named
    // option{N}-{productId}-list, N being the option's position — condition/finish can
    // sit at any position, and a third+ option (e.g. Edition, or Size/Color on non-TCG
    // merch) gets a select, mirroring sections/product.liquid's fallback. The "-list"
    // suffix keeps this row's radios out of the grid card's radio groups when both render
    // for the same product at once (see sections/product-card-fragment.liquid).
    var optionControls = card.querySelectorAll('[data-list-option-control]');
    // Unlike product-card.liquid there's no holo-foil effect on the list row to key off
    // finish, so only condKey (used by resyncGroups' stock badge below) is needed here.
    var condKey = 'option' + (card.dataset.conditionPosition || '1');

    // Group controls by option key, in first-seen order. optionControls comes back from
    // the DOM in render order (condition, then finish, then any extra options), which is
    // also the cascade order below.
    var orderedKeys = [];
    var controlsByKey = {};
    optionControls.forEach(function(control) {
      var key = control.name.split('-')[0];
      if (!controlsByKey[key]) {
        controlsByKey[key] = [];
        orderedKeys.push(key);
      }
      controlsByKey[key].push(control);
    });

    // Read the full selection across every control type: a radio only contributes when
    // checked (unchecked siblings would otherwise overwrite the selected value), while a
    // select or hidden input always contributes its current value.
    function readSelection() {
      var selected = {};
      optionControls.forEach(function(control) {
        var key = control.name.split('-')[0];
        if (control.type === 'radio') {
          if (control.checked) selected[key] = control.value;
        } else {
          selected[key] = control.value;
        }
      });
      return selected;
    }

    // Cheapest available real-priced candidate; else the most expensive real-priced
    // candidate (mirrors the Liquid sold-out anchor); else an available candidate over
    // array order; else whatever's left. Never a blind first-in-array match — that's what
    // let a $0 sold-out edition placeholder win over the real in-stock variant (SID-824).
    function pickBestVariant(candidates) {
      if (!candidates.length) return null;
      var availablePriced = candidates.filter(function(v) { return v.available && v.price > 0; });
      if (availablePriced.length) {
        return availablePriced.reduce(function(best, v) { return v.price < best.price ? v : best; });
      }
      var priced = candidates.filter(function(v) { return v.price > 0; });
      if (priced.length) {
        return priced.reduce(function(best, v) { return v.price > best.price ? v : best; });
      }
      return candidates.find(function(v) { return v.available; }) || candidates[0];
    }

    // Write a resolved variant's option values into every control for the given keys
    // (radios checked, selects/hidden inputs' values set).
    function writeControls(keys, variant) {
      keys.forEach(function(key) {
        var value = variant[key];
        if (value == null) return;
        (controlsByKey[key] || []).forEach(function(control) {
          if (control.type === 'radio') {
            control.checked = control.value === value;
          } else {
            control.value = value;
          }
        });
      });
    }

    // Resolve a selection into a variant, apply it, and re-sync every group's disabled
    // state. Two entry points:
    //   - preferredId (init, price sort): short-circuits straight to that exact variant
    //     and syncs every control to it — there's no single "changed" control to anchor on.
    //   - changedKey (a shopper's click/select): keeps every group at or above changedKey
    //     exactly as the shopper left it. Groups BELOW it keep their current value when a
    //     variant still exists that carries it (clicking NM while on Foil must not silently
    //     flip to Non-Foil just because Non-Foil happens to be cheaper); only a group whose
    //     current value no longer has a matching variant gets re-resolved.
    function applySelection(opts) {
      opts = opts || {};
      var preferredId = opts.preferredId;
      var changedKey = opts.changedKey;
      var selected = readSelection();
      var variant = null;

      if (preferredId != null) {
        variant = variants.find(function(v) { return v.id === preferredId; }) || null;
        // Preferred variant may not match the controls' current values at all (price sort
        // can land on a different condition/finish/edition entirely) -- sync every control
        // to it, not just the ones that happen to already agree.
        if (variant) writeControls(orderedKeys, variant);
      }

      if (!variant && changedKey != null) {
        var changedIdx = orderedKeys.indexOf(changedKey);
        if (changedIdx < 0) return;
        var prefixKeys = orderedKeys.slice(0, changedIdx + 1);
        var candidates = variants.filter(function(v) {
          return prefixKeys.every(function(key) { return v[key] === selected[key]; });
        });
        // Defensive: the disabled-state resync below should keep a shopper from ever
        // reaching an impossible combination, but never leave the DOM half-updated if one
        // slips through anyway.
        if (!candidates.length) candidates = variants;

        // Prefer candidates that also keep every lower group's current value -- only fall
        // through to re-resolving a lower group when none of the candidates can keep it.
        var lowerKeys = orderedKeys.slice(changedIdx + 1);
        var keepLower = candidates.filter(function(v) {
          return lowerKeys.every(function(k) { return selected[k] == null || v[k] === selected[k]; });
        });
        var keepLowerUsable = keepLower.filter(function(v) { return v.available && v.price > 0; });
        if (keepLowerUsable.length) candidates = keepLowerUsable;

        variant = pickBestVariant(candidates);
        if (variant) {
          // No-op for any lower control whose value the resolved variant already carries.
          writeControls(orderedKeys.filter(function(key, idx) { return idx > changedIdx; }), variant);
        }
      }

      if (!variant) {
        var allCandidates = variants.filter(function(v) {
          return orderedKeys.every(function(key) { return v[key] === selected[key]; });
        });
        if (!allCandidates.length) allCandidates = variants;
        variant = pickBestVariant(allCandidates);
        if (variant) writeControls(orderedKeys, variant);
      }

      if (!variant) return;

      applyVariantToForm(variant);
      resyncGroups(readSelection());
    }

    // Apply the resolved variant to price/stock/qty/playset -- but never rewrite the
    // server-rendered price string when the resolved variant is the one already painted:
    // the Liquid `| money` output must survive load untouched, and it also means a
    // resolution that didn't actually move the variant can't flicker the price.
    function applyVariantToForm(variant) {
      var currentId = variantInput ? parseInt(variantInput.value, 10) : null;
      if (variantInput) variantInput.value = variant.id;
      if (currentId === variant.id) return;

      var formattedPrice = formatMoney(variant.price);
      if (priceEl) priceEl.textContent = formattedPrice;
      if (priceMobileEl) priceMobileEl.textContent = formattedPrice;

      var hasStockBadge = variant.inventory_quantity != null && variant.inventory_quantity > 0 && variant.inventory_quantity <= 10;
      if (stockEl) {
        if (hasStockBadge) {
          stockEl.textContent = variant.inventory_quantity + ' in stock';
          stockEl.style.display = '';
        } else {
          stockEl.style.display = 'none';
        }
      }
      if (stockMobileEl) {
        if (hasStockBadge) {
          stockMobileEl.textContent = variant.inventory_quantity + ' in stock';
          stockMobileEl.style.display = '';
        } else {
          stockMobileEl.style.display = 'none';
        }
      }

      if (qtyInput && variant.inventory_quantity) {
        qtyInput.max = variant.inventory_quantity;
        if (parseInt(qtyInput.value) > variant.inventory_quantity) {
          qtyInput.value = variant.inventory_quantity;
        }
      }

      if (playsetBtn) {
        var playsetSize = parseInt(playsetBtn.dataset.playsetSize) || 4;
        var qty = variant.inventory_quantity;
        var hasEnoughStock = (qty == null && variant.available) || (qty != null && qty >= playsetSize);
        if (hasEnoughStock) {
          playsetBtn.classList.remove('product-card-list__playset-btn--hidden');
          playsetBtn.disabled = false;
        } else {
          playsetBtn.classList.add('product-card-list__playset-btn--hidden');
          playsetBtn.disabled = true;
        }
      }
    }

    // Re-sync every group's enabled/disabled state after every resolution (change, price
    // sort, init): a value is enabled iff at least one available, real-priced variant
    // carries it AND matches the current selection of every group ABOVE it — never the
    // groups below, since standard cascading selection only constrains downward. This is
    // the re-sync that stops a shopper from ever selecting a $0 sold-out combination from a
    // dropdown, and keeps a swatch from reading available when nothing behind it is.
    function resyncGroups(selected) {
      orderedKeys.forEach(function(key, idx) {
        var prefixKeys = orderedKeys.slice(0, idx);
        (controlsByKey[key] || []).forEach(function(control) {
          if (control.type === 'radio') {
            var matching = variants.filter(function(v) {
              return v[key] === control.value && prefixKeys.every(function(k) { return v[k] === selected[k]; });
            });
            var isValid = matching.some(function(v) { return v.available && v.price > 0; });
            var swatch = control.closest('[data-list-swatch]');
            if (swatch) {
              swatch.classList.toggle('product-card-list__swatch--unavailable', !isValid);
              // Condition swatches also carry a low-stock badge. Unconstrained by
              // finish/edition on purpose — condition has nothing above it in the cascade.
              // Gated on card.dataset.conditionPosition (only set when condition was
              // actually detected) so a non-TCG product's first group -- which key ===
              // condKey would otherwise match by the condKey fallback default -- doesn't
              // sprout a spurious "(n)" badge.
              if (key === condKey && card.dataset.conditionPosition) {
                var stock = matching.reduce(function(sum, v) {
                  return v.available && v.price > 0 && v.inventory_quantity != null && v.inventory_quantity > 0
                    ? sum + v.inventory_quantity
                    : sum;
                }, 0);
                swatch.dataset.conditionStock = stock;
                updateStockBadge(swatch, stock);
              }
            }
            // Never disable the currently checked radio so the selection can't get stuck;
            // always re-enable a radio whose value is valid again.
            control.disabled = isValid ? false : !control.checked;
          } else if (control.tagName === 'SELECT') {
            Array.from(control.options).forEach(function(opt) {
              opt.disabled = !variants.some(function(v) {
                return v[key] === opt.value && v.available && v.price > 0 &&
                  prefixKeys.every(function(k) { return v[k] === selected[k]; });
              });
            });
          }
          // Hidden inputs carry a single fixed value; nothing to toggle.
        });
      });
    }

    function updateStockBadge(swatch, stock) {
      var stockBadge = swatch.querySelector('[data-condition-stock-badge]');
      if (stock > 0 && stock <= 10) {
        if (stockBadge) {
          stockBadge.textContent = '(' + stock + ')';
          stockBadge.style.display = '';
        } else {
          var label = swatch.querySelector('.product-card-list__swatch-label');
          if (label) {
            var newBadge = document.createElement('span');
            newBadge.className = 'product-card-list__swatch-stock';
            newBadge.dataset.conditionStockBadge = '';
            newBadge.textContent = '(' + stock + ')';
            label.appendChild(newBadge);
          }
        }
      } else if (stockBadge) {
        stockBadge.style.display = 'none';
      }
    }

    // Use event delegation instead of attaching to each control individually.
    card.addEventListener('change', function(e) {
      var control = e.target.closest('[data-list-option-control]');
      if (!control && !e.target.closest('[data-list-swatch]')) return;
      applySelection({ changedKey: control ? control.name.split('-')[0] : undefined });
    });

    // Surface the price-extreme variant when the filtered grid is sorted by price, so
    // the displayed price + add-to-cart variant match where the row sits in the list:
    // cheapest in-stock variant on low→high, priciest on high→low. The Sideboard grid
    // calls this after injecting a card (see collection-filters.liquid).
    card.sideboardApplyPriceSort = function(direction) {
      if (!variants.length) return;
      var pool = variants.filter(function(v) { return v.available && v.price > 0; });
      // Sold out: no available variant, so anchor on the most expensive (book value)
      // regardless of sort direction, matching the server's ranking (sold-out rows sort
      // to the end either way).
      var soldOut = false;
      if (!pool.length) { pool = variants.filter(function(v) { return v.price > 0; }); soldOut = true; }
      if (!pool.length) return;

      var wantMax = soldOut ? true : direction === 'price-descending';
      var target = pool.reduce(function(best, v) {
        if (!best) return v;
        return (wantMax ? v.price > best.price : v.price < best.price) ? v : best;
      }, null);
      if (!target) return;

      if (optionControls.length) {
        applySelection({ preferredId: target.id });
      } else if (variantInput) {
        // No controls rendered: set the price + add-to-cart id directly.
        variantInput.value = target.id;
        var formattedPrice = formatMoney(target.price);
        if (priceEl) priceEl.textContent = formattedPrice;
        if (priceMobileEl) priceMobileEl.textContent = formattedPrice;
      }
    };

    // Sync client-side selection state once at init — chiefly so every group gets its
    // cascade-aware disabled/stock state before the shopper's first click. Preferring the
    // server-rendered variant id keeps this landing on exactly what already painted (see
    // applyVariantToForm — it skips the price/stock/qty writes when the id doesn't change).
    if (variantInput && optionControls.length) {
      applySelection({ preferredId: parseInt(variantInput.value, 10) });
    }

    // Add to cart handler - uses Cart API for unified state management
    if (addBtn && form) {
      form.addEventListener('submit', async function(e) {
        e.preventDefault();

        var variantId = variantInput ? variantInput.value : null;
        var quantity = parseInt(qtyInput ? qtyInput.value : 1) || 1;

        if (!variantId) return;

        addBtn.classList.add('is-loading');
        addBtn.disabled = true;

        // Use Cart API if available, otherwise fallback to form submit
        if (window.Sideboard && window.Sideboard.cart) {
          try {
            await window.Sideboard.cart.add([{ id: parseInt(variantId), quantity: quantity }]);

            addBtn.classList.remove('is-loading');
            addBtn.classList.add('is-success');

            // Reset after 1.5 seconds
            setTimeout(function() {
              addBtn.classList.remove('is-success');
              addBtn.disabled = false;
            }, 1500);
          } catch (error) {
            addBtn.classList.remove('is-loading');
            addBtn.disabled = false;
            console.error('Add to cart error:', error);
          }
        } else {
          // Fallback to native form submit
          form.submit();
        }
      });
    }

    // Playset quick add - uses Cart API for unified state management
    if (playsetBtn) {
      var goToCheckout = card.hasAttribute('data-playset-checkout');

      playsetBtn.addEventListener('click', async function(e) {
        e.preventDefault();
        var size = parseInt(playsetBtn.dataset.playsetSize) || 4;
        var variantId = variantInput ? variantInput.value : null;

        if (!variantId) return;

        // Validate variant ID against known variants
        var validVariant = variants.find(function(v) {
          return v.id === parseInt(variantId);
        });
        if (!validVariant) {
          console.error('Invalid variant ID:', variantId);
          return;
        }

        playsetBtn.disabled = true;

        // Use Cart API if available
        if (window.Sideboard && window.Sideboard.cart) {
          try {
            await window.Sideboard.cart.add([{ id: parseInt(variantId), quantity: size }]);

            if (goToCheckout) {
              window.location.href = '/checkout';
            } else {
              playsetBtn.disabled = false;
            }
          } catch (error) {
            playsetBtn.disabled = false;
            console.error('Playset add error:', error);
          }
        } else {
          // Fallback to direct fetch
          try {
            var response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: size }] })
            });
            var data = await response.json();

            if (goToCheckout) {
              window.location.href = '/checkout';
            } else {
              playsetBtn.disabled = false;
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
            }
          } catch (error) {
            playsetBtn.disabled = false;
            console.error('Playset add error:', error);
          }
        }
      });
    }
  }

  // Bind every list card under `root` (defaults to the whole document).
  function initCards(root) {
    (root || document).querySelectorAll('[data-product-card-list]').forEach(initCard);
  }

  initCards(document);

  // AJAX filtering/pagination swaps in fresh cards; re-bind them when that fires.
  document.addEventListener('collection:updated', function(e) {
    var container = e.detail && e.detail.container ? e.detail.container : document;
    initCards(container);
  });

  // Register this list-card initializer alongside the grid card's, so the
  // >5k filtered grid binds both injected card variants without firing collection:updated.
  window.SideboardCardInit = window.SideboardCardInit || [];
  window.SideboardCardInit.push(initCards);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function() {
  // Mobile detection helper
  const isMobile = () => window.innerWidth <= 990;

  // Format money using Shopify's formatter or fallback. Guarded the same way
  // snippets/cart-api.liquid does, so a page where window.Shopify hasn't loaded yet can't
  // throw here.
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // Single delegated click handler for closing expanded cards (prevents listener
  // leak). Queries cards live so it keeps working after the grid is swapped by
  // AJAX filtering/pagination.
  document.addEventListener('click', (e) => {
    if (!isMobile()) return;

    document.querySelectorAll('[data-product-card].is-expanded').forEach(card => {
      if (card.contains(e.target)) return;

      card.classList.remove('is-expanded');
      const expandBtn = card.querySelector('[data-expand-toggle]');
      if (expandBtn) expandBtn.setAttribute('aria-expanded', 'false');
    });
  });

  // Bind one card's interactive controls. Guarded so a card is never bound twice.
  function initCard(card) {
    if (card.dataset.cardInit) return;
    card.dataset.cardInit = 'true';
    const mobileStyle = card.dataset.mobileStyle;
    const isOverlay = card.classList.contains('product-card--overlay');

    // Mobile tap-to-expand functionality
    if (isOverlay && mobileStyle === 'tap_to_expand') {
      const mediaArea = card.querySelector('.product-card__media');
      if (mediaArea) {
        mediaArea.addEventListener('click', (e) => {
          if (!isMobile()) return;
          // Don't toggle if clicking on a link or the controls themselves
          if (e.target.closest('a') || e.target.closest('.product-card__controls--overlay')) return;
          e.preventDefault();
          card.classList.toggle('is-expanded');
        });
      }
    }

    // Mobile expand button functionality
    if (isOverlay && mobileStyle === 'expand_button') {
      const expandBtn = card.querySelector('[data-expand-toggle]');
      if (expandBtn) {
        expandBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const isExpanded = card.classList.toggle('is-expanded');
          expandBtn.setAttribute('aria-expanded', isExpanded);
        });
      }
    }

    const form = card.querySelector('[data-product-form]');
    if (!form) return;

    const variantInput = form.querySelector('[data-variant-id]');
    const qtyInput = form.querySelector('[data-qty-input]');
    const decreaseBtn = form.querySelector('[data-qty-decrease]');
    const increaseBtn = form.querySelector('[data-qty-increase]');
    const playsetBtn = form.querySelector('[data-playset-add]');
    const priceEl = card.querySelector('[data-product-price]');
    const stockEl = card.querySelector('[data-product-stock]');
    const variantsJson = card.querySelector('[data-product-variants]');

    let variants = [];
    if (variantsJson) {
      try {
        variants = JSON.parse(variantsJson.textContent);
      } catch (e) {
        console.error('Failed to parse variants:', e);
      }
    }

    // A missing/invalid max attribute falls back to 99 (untracked inventory); a real max of
    // 0 (sold out) must NOT fall back — `parseInt(qtyInput.max) || 99` did exactly that,
    // since 0 is falsy in JS, which is what let + count past a sold-out variant's stock.
    function qtyMax() {
      const max = parseInt(qtyInput.max, 10);
      return Number.isNaN(max) ? 99 : max;
    }

    // Quantity controls. − reads disabled at 1 and + at the variant's stock limit (so with
    // 1 in stock both read disabled), kept in sync on every change to the value or the max,
    // not just at render, since typing a quantity or switching variants can hit either edge.
    // qtyInput.disabled is the single source of truth for "this variant can't be bought at
    // all" (sold-out product on load, sold-out variant after a swatch switch) — when it's
    // set, both buttons stay disabled regardless of what value/max happen to compare to,
    // instead of the max comparison alone re-enabling a button a disabled input already ruled out.
    function updateQtyButtons() {
      if (!qtyInput) return;
      if (qtyInput.disabled) {
        if (decreaseBtn) decreaseBtn.disabled = true;
        if (increaseBtn) increaseBtn.disabled = true;
        return;
      }
      const current = parseInt(qtyInput.value) || 1;
      const max = qtyMax();
      if (decreaseBtn) decreaseBtn.disabled = current <= 1;
      if (increaseBtn) increaseBtn.disabled = current >= max;
    }
    updateQtyButtons();

    if (decreaseBtn && qtyInput) {
      decreaseBtn.addEventListener('click', () => {
        const current = parseInt(qtyInput.value) || 1;
        if (current > 1) qtyInput.value = current - 1;
        updateQtyButtons();
      });
    }

    if (increaseBtn && qtyInput) {
      increaseBtn.addEventListener('click', () => {
        const current = parseInt(qtyInput.value) || 1;
        const max = qtyMax();
        if (current < max) qtyInput.value = current + 1;
        updateQtyButtons();
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('input', updateQtyButtons);
    }

    // Add to cart button - use Cart API
    const addBtn = form.querySelector('.product-card__add-btn');
    // Captured for the cascade's defensive re-sync (syncAddButton below): only the live
    // "Add" button has a label to restore to and a sold-out label to swap in -- a card
    // whose product is fully sold out already rendered the permanent disabled sold-out
    // button, with nothing to toggle.
    const addBtnAvailableLabel = addBtn && !addBtn.disabled ? addBtn.textContent.trim() : null;
    const addBtnSoldOutLabel = addBtn ? addBtn.dataset.soldOutLabel || null : null;
    if (addBtn) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        // Use Cart API if available
        if (window.Sideboard && window.Sideboard.cart) {
          const variantId = variantInput.value;
          const quantity = parseInt(qtyInput?.value) || 1;

          addBtn.classList.add('is-loading');
          addBtn.disabled = true;

          try {
            await window.Sideboard.cart.add([{ id: parseInt(variantId), quantity: quantity }]);

            // Brief success state
            addBtn.classList.remove('is-loading');
            addBtn.classList.add('is-success');
            const originalText = addBtn.textContent;
            addBtn.textContent = '✓';

            setTimeout(() => {
              addBtn.classList.remove('is-success');
              addBtn.textContent = originalText;
              addBtn.disabled = false;
            }, 1000);
          } catch (err) {
            console.error('Add to cart error:', err);
            addBtn.classList.remove('is-loading');
            addBtn.disabled = false;
          }
        } else {
          // Fallback: submit form normally
          form.submit();
        }
      });
    }

    // Playset quick add - use Cart API
    if (playsetBtn && qtyInput) {
      const goToCheckout = card.hasAttribute('data-playset-checkout');

      playsetBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        const size = parseInt(playsetBtn.dataset.playsetSize) || 4;
        const variantId = variantInput.value;

        // Use Cart API if available
        if (window.Sideboard && window.Sideboard.cart) {
          playsetBtn.classList.add('is-loading');
          playsetBtn.disabled = true;

          try {
            await window.Sideboard.cart.add([{ id: parseInt(variantId), quantity: size }]);

            if (goToCheckout) {
              window.location.href = '/checkout';
            } else {
              // Brief success indication
              playsetBtn.classList.remove('is-loading');
              playsetBtn.disabled = false;
            }
          } catch (err) {
            console.error('Playset add error:', err);
            playsetBtn.classList.remove('is-loading');
            playsetBtn.disabled = false;
          }
        } else if (goToCheckout) {
          // Fallback: fetch then redirect
          try {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: size }] })
            });
            window.location.href = '/checkout';
          } catch (err) {
            qtyInput.value = size;
            form.requestSubmit();
          }
        } else {
          qtyInput.value = size;
          form.requestSubmit();
        }
      });
    }

    // Option selection - cascading variant resolution, the standard Shopify pattern
    // ("select down"): a group only constrains the groups rendered BELOW it, never the
    // groups above. Every option control (radio swatch, fallback <select>, or hidden input
    // for a single-value option) carries data-option-control and is named
    // option{N}-{productId}, N being the option's position — condition/finish can sit at
    // any position (the app has published single-"Title" products), and a third+ option
    // (e.g. Edition) gets a select, mirroring sections/product.liquid's fallback.
    const optionControls = card.querySelectorAll('[data-option-control]');
    const priceCurrentEl = priceEl ? priceEl.querySelector('.product-card__price-current') : null;
    const condKey = 'option' + (card.dataset.conditionPosition || '1');
    const finKey = card.dataset.finishPosition ? 'option' + card.dataset.finishPosition : null;

    // Group controls by option key, in first-seen order. optionControls comes back from
    // the DOM in render order (condition, then finish, then any extra options), which is
    // also the cascade order below.
    const orderedKeys = [];
    const controlsByKey = {};
    optionControls.forEach(control => {
      const key = control.name.split('-')[0];
      if (!controlsByKey[key]) {
        controlsByKey[key] = [];
        orderedKeys.push(key);
      }
      controlsByKey[key].push(control);
    });

    // Read the full selection across every control type: a radio only contributes when
    // checked (unchecked siblings would otherwise overwrite the selected value), while a
    // select or hidden input always contributes its current value.
    function readSelection() {
      const selected = {};
      optionControls.forEach(control => {
        const key = control.name.split('-')[0];
        if (control.type === 'radio') {
          if (control.checked) selected[key] = control.value;
        } else {
          selected[key] = control.value;
        }
      });
      return selected;
    }

    // Cheapest available real-priced candidate; else the most expensive real-priced
    // candidate (mirrors the Liquid sold-out anchor); else an available candidate over
    // array order; else whatever's left. Never a blind first-in-array match — that's what
    // let a $0 sold-out edition placeholder win over the real in-stock variant (SID-824).
    function pickBestVariant(candidates) {
      if (!candidates.length) return null;
      const availablePriced = candidates.filter(v => v.available && v.price > 0);
      if (availablePriced.length) {
        return availablePriced.reduce((best, v) => (v.price < best.price ? v : best));
      }
      const priced = candidates.filter(v => v.price > 0);
      if (priced.length) {
        return priced.reduce((best, v) => (v.price > best.price ? v : best));
      }
      return candidates.find(v => v.available) || candidates[0];
    }

    // Write a resolved variant's option values into every control for the given keys
    // (radios checked, selects/hidden inputs' values set).
    function writeControls(keys, variant) {
      keys.forEach(key => {
        const value = variant[key];
        if (value == null) return;
        (controlsByKey[key] || []).forEach(control => {
          if (control.type === 'radio') {
            control.checked = control.value === value;
          } else {
            control.value = value;
          }
        });
      });
    }

    // Resolve a selection into a variant, apply it, and re-sync every group's disabled
    // state. Two entry points:
    //   - preferredId (init, price sort): short-circuits straight to that exact variant
    //     and syncs every control to it — there's no single "changed" control to anchor on.
    //   - changedKey (a shopper's click/select): keeps every group at or above changedKey
    //     exactly as the shopper left it. Groups BELOW it keep their current value when a
    //     variant still exists that carries it (clicking NM while on Foil must not silently
    //     flip to Non-Foil just because Non-Foil happens to be cheaper); only a group whose
    //     current value no longer has a matching variant gets re-resolved.
    function applySelection({ preferredId, changedKey } = {}) {
      const selected = readSelection();
      let variant = null;

      if (preferredId != null) {
        variant = variants.find(v => v.id === preferredId) || null;
        // Preferred variant may not match the controls' current values at all (price sort
        // can land on a different condition/finish/edition entirely) -- sync every control
        // to it, not just the ones that happen to already agree.
        if (variant) writeControls(orderedKeys, variant);
      }

      if (!variant && changedKey != null) {
        const changedIdx = orderedKeys.indexOf(changedKey);
        if (changedIdx < 0) return;
        const prefixKeys = orderedKeys.slice(0, changedIdx + 1);
        let candidates = variants.filter(v => prefixKeys.every(key => v[key] === selected[key]));
        // Defensive: the disabled-state resync below should keep a shopper from ever
        // reaching an impossible combination, but never leave the DOM half-updated if one
        // slips through anyway.
        if (!candidates.length) candidates = variants;

        // Prefer candidates that also keep every lower group's current value -- only fall
        // through to re-resolving a lower group when none of the candidates can keep it.
        const lowerKeys = orderedKeys.slice(changedIdx + 1);
        const keepLower = candidates.filter(v =>
          lowerKeys.every(k => selected[k] == null || v[k] === selected[k]));
        const keepLowerUsable = keepLower.filter(v => v.available && v.price > 0);
        if (keepLowerUsable.length) candidates = keepLowerUsable;

        variant = pickBestVariant(candidates);
        if (variant) {
          // No-op for any lower control whose value the resolved variant already carries.
          writeControls(orderedKeys.filter((key, idx) => idx > changedIdx), variant);
        }
      }

      if (!variant) {
        let candidates = variants.filter(v => orderedKeys.every(key => v[key] === selected[key]));
        if (!candidates.length) candidates = variants;
        variant = pickBestVariant(candidates);
        if (variant) writeControls(orderedKeys, variant);
      }

      if (!variant) return;

      applyVariantToForm(variant);
      resyncGroups(readSelection());
      syncAddButton(variant);
    }

    // Shared purchasable test: a variant is buyable only when Shopify marks it available AND
    // it carries a real price (a sold-out TCG condition/finish sits at $0 but can still read
    // .available under some inventory policies). Both the qty stepper and the Add button gate
    // on this one test so they never disagree about the same resolved variant.
    function isVariantPurchasable(variant) {
      return variant.available && variant.price > 0;
    }

    // Apply the resolved variant to price/stock/qty/playset/holo — but never rewrite the
    // server-rendered price string when the resolved variant is the one already painted
    // (review finding B): the Liquid `| money` output must survive load untouched, and it
    // also means a resolution that didn't actually move the variant can't flicker the price.
    function applyVariantToForm(variant) {
      const currentId = variantInput ? parseInt(variantInput.value, 10) : null;
      if (variantInput) variantInput.value = variant.id;
      if (currentId === variant.id) return;

      if (priceCurrentEl) {
        priceCurrentEl.textContent = formatMoney(variant.price);
      }

      if (stockEl && variant.inventory_quantity != null) {
        if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 10) {
          stockEl.textContent = variant.inventory_quantity + ' in stock';
          stockEl.style.display = '';
        } else {
          stockEl.style.display = 'none';
        }
      }

      // Mirrors syncAddButton's own purchasable test below (same variant, same rule) so
      // switching to a sold-out variant disables the stepper along with the Add button,
      // instead of leaving it capped at whatever variant.inventory_quantity it last saw.
      if (qtyInput) {
        const purchasable = isVariantPurchasable(variant);
        qtyInput.disabled = !purchasable;
        if (decreaseBtn) decreaseBtn.disabled = !purchasable;
        if (increaseBtn) increaseBtn.disabled = !purchasable;
        if (purchasable) {
          qtyInput.max = variant.inventory_quantity > 0 ? variant.inventory_quantity : 99;
          if (parseInt(qtyInput.value) > parseInt(qtyInput.max, 10)) {
            qtyInput.value = qtyInput.max;
          }
        }
        updateQtyButtons();
      }

      if (playsetBtn) {
        const playsetSize = parseInt(playsetBtn.dataset.playsetSize) || 4;
        // Show if: no inventory tracking (null/undefined), OR enough stock, OR variant is available with untracked inventory
        const qty = variant.inventory_quantity;
        const hasEnoughStock = (qty == null && variant.available) || (qty != null && qty >= playsetSize);
        playsetBtn.style.display = hasEnoughStock ? '' : 'none';
      }

      // Holo-foil: intensify the shimmer when a Foil finish is selected (for combined
      // single-option products foil-ness lives in the condition value itself)
      if (window.HoloFoil) {
        const holoStage = card.querySelector('[data-holo]');
        const foilSource = ((finKey && variant[finKey]) || variant[condKey] || '').toLowerCase();
        if (holoStage) window.HoloFoil.setFoil(holoStage, foilSource.includes('foil') && !foilSource.includes('non-foil'));
      }
    }

    // Re-sync every group's enabled/disabled state after every resolution (change, price
    // sort, init): a value is enabled iff at least one available, real-priced variant
    // carries it AND matches the current selection of every group ABOVE it — never the
    // groups below, since standard cascading selection only constrains downward. This is
    // the re-sync that stops a shopper from ever selecting a $0 sold-out combination from a
    // dropdown, and keeps a swatch from reading available when nothing behind it is.
    function resyncGroups(selected) {
      orderedKeys.forEach((key, idx) => {
        const prefixKeys = orderedKeys.slice(0, idx);
        (controlsByKey[key] || []).forEach(control => {
          if (control.type === 'radio') {
            const matching = variants.filter(v => (
              v[key] === control.value && prefixKeys.every(k => v[k] === selected[k])
            ));
            const isValid = matching.some(v => v.available && v.price > 0);
            const swatch = control.closest('[data-swatch]');
            if (swatch) {
              swatch.classList.toggle('product-card__swatch--unavailable', !isValid);
              // Condition swatches also carry a low-stock badge. Unconstrained by
              // finish/edition on purpose — condition has nothing above it in the cascade.
              // Gated on card.dataset.conditionPosition (only set when condition was
              // actually detected) so a non-TCG product's first group -- which key === condKey
              // would otherwise match by the condKey fallback default -- doesn't sprout a
              // spurious "(n)" badge.
              if (key === condKey && card.dataset.conditionPosition) {
                const stock = matching.reduce((sum, v) => (
                  v.available && v.price > 0 && v.inventory_quantity != null && v.inventory_quantity > 0
                    ? sum + v.inventory_quantity
                    : sum
                ), 0);
                swatch.dataset.conditionStock = stock;
                updateStockBadge(swatch, stock);
              }
            }
            // Never disable the currently checked radio so the selection can't get stuck;
            // always re-enable a radio whose value is valid again.
            control.disabled = isValid ? false : !control.checked;
          } else if (control.tagName === 'SELECT') {
            Array.from(control.options).forEach(opt => {
              opt.disabled = !variants.some(v => (
                v[key] === opt.value && v.available && v.price > 0 &&
                prefixKeys.every(k => v[k] === selected[k])
              ));
            });
          }
          // Hidden inputs carry a single fixed value; nothing to toggle.
        });
      });
    }

    function updateStockBadge(swatch, stock) {
      const stockBadge = swatch.querySelector('[data-condition-stock-badge]');
      if (stock > 0 && stock <= 10) {
        if (stockBadge) {
          stockBadge.textContent = '(' + stock + ')';
          stockBadge.style.display = '';
        } else {
          const label = swatch.querySelector('.product-card__swatch-label');
          if (label) {
            const newBadge = document.createElement('span');
            newBadge.className = 'product-card__swatch-stock';
            newBadge.dataset.conditionStockBadge = '';
            newBadge.textContent = '(' + stock + ')';
            label.appendChild(newBadge);
          }
        }
      } else if (stockBadge) {
        stockBadge.style.display = 'none';
      }
    }

    // Defensive: if the resolved variant is unavailable anyway (a fully sold-out corner of
    // the cascade), disable the Add button and swap in the theme's own sold-out label/class
    // — never new hardcoded text. Only applies to a card that rendered the live "Add"
    // button; a card whose product is fully sold out already rendered the permanent
    // disabled sold-out button, with nothing to toggle.
    function syncAddButton(variant) {
      if (!addBtn || addBtnAvailableLabel == null) return;
      // Never touch the button mid add-to-cart -- it could re-enable a button the click
      // handler just disabled, or stomp the success checkmark before its timeout restores
      // the label.
      if (addBtn.classList.contains('is-loading') || addBtn.classList.contains('is-success')) return;
      const isAvailable = isVariantPurchasable(variant);
      addBtn.disabled = !isAvailable;
      if (isAvailable) {
        addBtn.removeAttribute('aria-disabled');
        addBtn.classList.remove('product-card__add-btn--sold-out');
        addBtn.textContent = addBtnAvailableLabel;
      } else {
        addBtn.setAttribute('aria-disabled', 'true');
        addBtn.classList.add('product-card__add-btn--sold-out');
        if (addBtnSoldOutLabel) addBtn.textContent = addBtnSoldOutLabel;
      }
    }

    // Use event delegation instead of attaching to each control individually.
    card.addEventListener('change', (e) => {
      const control = e.target.closest('[data-option-control]');
      if (!control && !e.target.closest('[data-swatch]')) return;
      applySelection({ changedKey: control ? control.name.split('-')[0] : undefined });
    });

    // Surface the price-extreme variant when the filtered grid is sorted by price, so
    // the displayed price + add-to-cart variant match where the card sits in the grid:
    // cheapest in-stock variant on low→high, priciest on high→low. The Sideboard grid
    // calls this after injecting a card (see collection-filters.liquid). It overrides
    // the foil-default landing selection for price sorts only — other sorts keep it.
    card.sideboardApplyPriceSort = (direction) => {
      if (!variants.length) return;
      let pool = variants.filter(v => v.available && v.price > 0);
      // Sold out: no available variant, so anchor on the most expensive (book value)
      // regardless of sort direction, matching the server's ranking (sold-out rows sort
      // to the end either way). NOTE: the Liquid render prefers Near Mint on sold-out
      // products and only falls back to most-expensive when there's no NM variant, so on
      // an irregular price ladder this can land the card on a different condition than
      // first paint did. Usually the same variant, since NM is usually the priciest.
      let soldOut = false;
      if (!pool.length) { pool = variants.filter(v => v.price > 0); soldOut = true; }
      if (!pool.length) return;

      const wantMax = soldOut ? true : direction === 'price-descending';
      const target = pool.reduce((best, v) => {
        if (!best) return v;
        return (wantMax ? v.price > best.price : v.price < best.price) ? v : best;
      }, null);
      if (!target) return;

      if (optionControls.length) {
        applySelection({ preferredId: target.id });
      } else if (variantInput) {
        // No controls rendered: set the price + add-to-cart id directly.
        variantInput.value = target.id;
        if (priceCurrentEl) priceCurrentEl.textContent = formatMoney(target.price);
      }
    };

    // Sync client-side selection state once at init — chiefly so every group gets its
    // cascade-aware disabled/stock state before the shopper's first click. Preferring the
    // server-rendered variant id keeps this landing on exactly what already painted (see
    // applyVariantToForm — it skips the price/stock/qty writes when the id doesn't change).
    if (variantInput && optionControls.length) {
      applySelection({ preferredId: parseInt(variantInput.value, 10) });
    }
  }

  // Bind every card under `root` (defaults to the whole document).
  function initCards(root) {
    (root || document).querySelectorAll('[data-product-card]').forEach(initCard);
  }

  initCards(document);

  // AJAX filtering/pagination swaps in fresh cards; re-bind them when that fires.
  document.addEventListener('collection:updated', (e) => {
    const container = e.detail && e.detail.container ? e.detail.container : document;
    initCards(container);
  });

  // Register this card's initializer so the filtered (>5k) grid can bind a
  // single injected card directly, without firing collection:updated (which would
  // also re-fetch the sidebar). initCards(root) scopes to [data-product-card] under
  // root, so passing one injected wrapper binds just that card.
  window.SideboardCardInit = window.SideboardCardInit || [];
  window.SideboardCardInit.push(initCards);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["restock-request"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-restock-button]');
    if (!button) return;

    const root = button.closest('[data-restock-request]');
    const messages = JSON.parse(root.querySelector('[data-restock-messages]').textContent);
    const output = root.querySelector('[data-restock-message]');
    let key = 'error';

    button.disabled = true;
    try {
      const response = await fetch('/apps/sideboard/v1/restock-requests', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new URLSearchParams({ product_id: button.dataset.productId })
      });
      const data = await response.json().catch(function () { return {}; });
      key = data.status || data.error;
    } catch (e) {
      key = 'error';
    }

    if (!messages[key]) key = 'error';
    output.textContent = messages[key];
    output.hidden = false;
    button.disabled = key === 'subscribed' || key === 'already_subscribed' || key === 'in_stock';
  });
  } catch(e) { console.error(e); }
})();

})();
